/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** UserStatus */
export enum UserStatus {
  Active = "Active",
  Inactive = "Inactive",
  Suspended = "Suspended",
}

/**
 * UserRole
 * Describes the roles a user can have within the system.
 */
export enum UserRole {
  Admin = "Admin",
  User = "User",
  Employee = "Employee",
  Dev = "Dev",
  FieldWorker = "FieldWorker",
}

/** TicketStatus */
export enum TicketStatus {
  Open = "Open",
  InProgress = "In Progress",
  Resolved = "Resolved",
  Closed = "Closed",
}

/** TicketPriority */
export enum TicketPriority {
  Low = "Low",
  Medium = "Medium",
  High = "High",
  Urgent = "Urgent",
}

/** TicketCategory */
export enum TicketCategory {
  Technical = "Technical",
  Billing = "Billing",
  FeatureRequest = "Feature Request",
  BugReport = "Bug Report",
  General = "General",
  Account = "Account",
}

/** ProjectStatusEnum */
export enum ProjectStatusEnum {
  Draft = "Draft",
  UnderDevelopment = "Under development",
}

/**
 * MediaType
 * Describes the type of media file.
 */
export enum MediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
}

/** DeviceType */
export enum DeviceType {
  AUDIO = "AUDIO",
  CAMERA = "CAMERA",
  SOIL_SENSOR = "SOIL_SENSOR",
}

/**
 * DeviceStatus
 * Describes the status of a device.
 */
export enum DeviceStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DEFECTIVE = "DEFECTIVE",
  LOW_BATTERY = "LOW_BATTERY",
  RETIRED = "RETIRED",
}

/**
 * DeploymentStatus
 * Describes the status of a deployment.
 */
export enum DeploymentStatus {
  Upcoming = "Upcoming",
  Past = "Past",
  Retrieved = "Retrieved",
  Completed = "Completed",
  Deployed = "Deployed",
  Inaccessible = "Inaccessible",
  Cancelled = "Cancelled",
}

/**
 * AcousticIndexEnum
 * Describes the acoustic indices
 */
export enum AcousticIndexEnum {
  Aci = "aci",
  Bi = "bi",
  Adi = "adi",
  Aei = "aei",
  Ndsi = "ndsi",
}

/** APIEndpointCreate */
export interface APIEndpointCreate {
  /**
   * Service Name
   * Service/module name (e.g., 'ESG Data', 'Reports')
   */
  service_name: string;
  /**
   * Path
   * API endpoint path (e.g., '/api/v1/esg/data')
   */
  path: string;
  /**
   * Method
   * HTTP method (GET, POST, PUT, DELETE)
   */
  method: string;
  /**
   * Description
   * Description of the endpoint
   */
  description?: string | null;
  /**
   * Enabled
   * Whether the endpoint is enabled
   * @default false
   */
  enabled?: boolean | null;
}

/** APIEndpointOut */
export interface APIEndpointOut {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Service Name */
  service_name: string;
  /** Path */
  path: string;
  /** Method */
  method: string;
  /** Description */
  description?: string | null;
  /** Enabled */
  enabled: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** APIEndpointQueryResult */
export interface APIEndpointQueryResult {
  /** Endpoints */
  endpoints: APIEndpointOut[];
  /** Count */
  count: number;
}

/** APIEndpointToggle */
export interface APIEndpointToggle {
  /**
   * Enabled
   * Enable or disable the endpoint
   */
  enabled: boolean;
}

/** APIEndpointUpdate */
export interface APIEndpointUpdate {
  /** Service Name */
  service_name?: string | null;
  /** Path */
  path?: string | null;
  /** Method */
  method?: string | null;
  /** Description */
  description?: string | null;
  /** Enabled */
  enabled?: boolean | null;
}

/**
 * APIKeyCreateResponse
 * Response schema for API key creation
 */
export interface APIKeyCreateResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Api Key
   * Full API key (shown only once)
   */
  api_key: string;
  /**
   * Key Prefix
   * @maxLength 20
   */
  key_prefix: string;
  /** Status */
  status: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Message
   * @default "API key created successfully. Store this key securely."
   */
  message?: string;
}

/**
 * APIKeyOut
 * Schema for API key output (no sensitive data)
 */
export interface APIKeyOut {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Key Prefix
   * First 15 characters of the API key
   * @maxLength 20
   */
  key_prefix: string;
  /**
   * Status
   * Status: active, revoked
   */
  status: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Last Used At */
  last_used_at?: string | null;
  /** Expires At */
  expires_at?: string | null;
  /** User Name */
  user_name?: string | null;
  /** User Email */
  user_email?: string | null;
}

/**
 * APIKeyPermissionsResponse
 * Response schema for API key permissions
 */
export interface APIKeyPermissionsResponse {
  /**
   * Api Key Id
   * @format uuid
   */
  api_key_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Permissions
   * List of permissions
   */
  permissions: Record<string, any>[];
  /**
   * Message
   * @default "API key permissions retrieved successfully"
   */
  message?: string;
}

/**
 * APIKeyQueryResult
 * Response schema for paginated API key list
 */
export interface APIKeyQueryResult {
  /** Api Keys */
  api_keys: APIKeyOut[];
  /**
   * Count
   * Total number of API keys matching the query
   */
  count: number;
}

/**
 * APIKeyRegenerateResponse
 * Response schema for API key regeneration
 */
export interface APIKeyRegenerateResponse {
  /**
   * Api Key Id
   * @format uuid
   */
  api_key_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Api Key
   * New full API key (shown only once)
   */
  api_key: string;
  /**
   * Message
   * @default "API key regenerated successfully"
   */
  message?: string;
}

/**
 * APIKeyRevokeResponse
 * Response schema for API key revocation
 */
export interface APIKeyRevokeResponse {
  /**
   * Api Key Id
   * @format uuid
   */
  api_key_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Message
   * @default "API key revoked successfully"
   */
  message?: string;
}

/**
 * APIKeyUsageResponse
 * Response schema for API key usage statistics
 */
export interface APIKeyUsageResponse {
  /**
   * Api Key Id
   * @format uuid
   */
  api_key_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Usage
   * Usage statistics
   */
  usage: Record<string, any>;
  /**
   * Message
   * @default "API key usage retrieved successfully"
   */
  message?: string;
}

/** APIRequestLogOut */
export interface APIRequestLogOut {
  /**
   * User Id
   * User ID (DEV role) this API key belongs to
   */
  user_id?: string | null;
  /**
   * Api Key Prefix
   * API key prefix
   */
  api_key_prefix?: string | null;
  /**
   * Endpoint Path
   * API endpoint path
   */
  endpoint_path: string;
  /**
   * Method
   * HTTP method
   */
  method: string;
  /**
   * Status Code
   * HTTP status code
   */
  status_code: number;
  /**
   * Response Time Ms
   * Response time in milliseconds
   */
  response_time_ms?: number | null;
  /**
   * Ip Address
   * IP address
   */
  ip_address?: string | null;
  /**
   * User Agent
   * User agent
   */
  user_agent?: string | null;
  /**
   * Created At
   * Created at
   */
  created_at?: string | null;
  /**
   * Id
   * ID
   * @format uuid
   */
  id: string;
}

/**
 * ActivityTrend
 * Activity trend data for one deployment.
 */
export interface ActivityTrend {
  /** Time Slots */
  time_slots: string[];
  /** Species Trends */
  species_trends: Record<string, any>;
}

/** AssessmentMediaDownloadRequest */
export interface AssessmentMediaDownloadRequest {
  /** Media Url */
  media_url: string;
}

/** AssessmentMediaUploadRequest */
export interface AssessmentMediaUploadRequest {
  /** File Name */
  file_name: string;
  /** Folder */
  folder: string;
  /** Content Type */
  content_type: string;
}

/**
 * Assignment
 * Schema for returning Assignment details to the client, including nested User and Project data.
 */
export interface Assignment {
  /**
   * User Id
   * ID of the assigned employee (User)
   * @format uuid
   * @example "cf419bdc-2e74-4617-8f6d-cc8dd2102dfd"
   */
  user_id: string;
  /**
   * Project Id
   * ID of the assigned project
   * @format uuid
   * @example "b56f8444-6d2c-4cda-a16b-b21e831bdfba"
   */
  project_id: string;
  /**
   * Assignment Id
   * @format uuid
   */
  assignment_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  user: AppSchemasUserUserResponse;
  project: Project;
}

/**
 * AssignmentCreate
 * Schema for creating a new Assignment.
 */
export interface AssignmentCreate {
  /**
   * User Id
   * ID of the assigned employee (User)
   * @format uuid
   * @example "cf419bdc-2e74-4617-8f6d-cc8dd2102dfd"
   */
  user_id: string;
  /**
   * Project Id
   * ID of the assigned project
   * @format uuid
   * @example "b56f8444-6d2c-4cda-a16b-b21e831bdfba"
   */
  project_id: string;
}

/** AudioProcessingRequest */
export interface AudioProcessingRequest {
  /**
   * File Id
   * @format uuid
   */
  file_id: string;
  /** Gcs Path */
  gcs_path: string;
}

/** AuditLogOut */
export interface AuditLogOut {
  /**
   * Admin User Id
   * Admin user ID
   */
  admin_user_id?: string | null;
  /**
   * Action
   * Action
   */
  action: string;
  /**
   * Entity Type
   * Entity type
   */
  entity_type: string;
  /**
   * Entity Id
   * Entity ID
   */
  entity_id?: string | null;
  /**
   * Details
   * Details
   */
  details?: Record<string, any> | null;
  /**
   * Reason
   * Reason
   */
  reason?: string | null;
  /**
   * Created At
   * Created at
   * @format date-time
   */
  created_at: string;
  /**
   * Id
   * ID
   * @format uuid
   */
  id: string;
}

/**
 * BatchFileFinalizeItem
 * A single file entry in a batch finalize request.
 */
export interface BatchFileFinalizeItem {
  /** Gcs Path */
  gcs_path: string;
  /** File Name */
  file_name: string;
}

/**
 * BatchFileFinalizeRequest
 * Request body for batch finalize upload.
 */
export interface BatchFileFinalizeRequest {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Files */
  files: BatchFileFinalizeItem[];
}

/**
 * BatchFileFinalizeResponse
 * Response for batch finalize — returns all created file records.
 */
export interface BatchFileFinalizeResponse {
  /** Queued */
  queued: number;
  /** Files */
  files: FileAdminDetailWithUser[];
}

/**
 * BatchFileUploadItem
 * A single file entry in a batch upload request.
 */
export interface BatchFileUploadItem {
  /** File Name */
  file_name: string;
  /** Content Type */
  content_type: string;
}

/**
 * BatchFileUploadRequest
 * Request body for batch signed URL generation.
 */
export interface BatchFileUploadRequest {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Files */
  files: BatchFileUploadItem[];
}

/**
 * BatchFileUploadResponseItem
 * A single item in the batch upload URL response.
 */
export interface BatchFileUploadResponseItem {
  /** File Name */
  file_name: string;
  /** Upload Url */
  upload_url: string;
  /** Gcs Path */
  gcs_path: string;
}

/** BiodiversityProjectAnalysis */
export interface BiodiversityProjectAnalysis {
  /** Cameras Installed */
  cameras_installed?: number | null;
  /** Audio Devices Installed */
  audio_devices_installed?: number | null;
  /** Total Images Videos */
  total_images_videos?: number | null;
  /** Total Audiofiles */
  total_audiofiles?: number | null;
  /** Exsitu Species Distribution */
  exsitu_species_distribution?:
    | SpeciesDistribution
    | Record<string, any>
    | null;
  /** Insitu Species Distribution */
  insitu_species_distribution?:
    | SpeciesDistribution
    | Record<string, any>
    | null;
  /** Biodiversity Score */
  biodiversity_score?: number | null;
  /** Species Diversity */
  species_diversity?: number | null;
  /** Taxonomic Dissimilarity */
  taxonomic_dissimilarity?: number | null;
  /** Species Richness */
  species_richness?: number | null;
  /** Habitat Health */
  habitat_health?: number | null;
  /** Mean Species Abundance */
  mean_species_abundance?: number | null;
  /** Mean Ndvi */
  mean_ndvi?: number | null;
  /** Cp Land */
  cp_land?: number | null;
  /** Hdi */
  hdi?: number | null;
  /** Insitu Data */
  insitu_data?: InSituData[] | null;
  /** Insitu Species Count */
  insitu_species_count?: number | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/** BiodiversitySiteAnalysis */
export interface BiodiversitySiteAnalysis {
  /**
   * Camera Installed
   * @default 0
   */
  camera_installed?: number | null;
  /**
   * Audio Devices
   * @default 0
   */
  audio_devices?: number | null;
  /**
   * Total Audiofiles
   * @default 0
   */
  total_audiofiles?: number | null;
  /**
   * Total Images Videos
   * @default 0
   */
  total_images_videos?: number | null;
  /** Biodiversity Score */
  biodiversity_score?: number | null;
  /** Mean Species Abundance */
  mean_species_abundance?: number | null;
  /** Species Richness */
  species_richness?: number | null;
  /** Species Diversity */
  species_diversity?: number | null;
  /** Taxonomic Dissimilarity */
  taxonomic_dissimilarity?: number | null;
  /** Habitat Health */
  habitat_health?: number | null;
  /** Mean Ndvi */
  mean_ndvi?: number | null;
  /** Cp Land */
  cp_land?: number | null;
  /** Hdi */
  hdi?: number | null;
  /** Insitu Data */
  insitu_data?: InSituData[] | null;
  /** Insitu Species Count */
  insitu_species_count?: number | null;
  /** Exsitu Species Distribution */
  exsitu_species_distribution?:
    | SpeciesDistribution
    | Record<string, any>
    | null;
  /** Insitu Species Distribution */
  insitu_species_distribution?:
    | SpeciesDistribution
    | Record<string, any>
    | null;
  /** Calculated At */
  calculated_at?: string | null;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/** Body_add_audio_location_api_v1_sites__site_id__add_audio_location_put */
export interface BodyAddAudioLocationApiV1SitesSiteIdAddAudioLocationPut {
  /**
   * Audio Zip File
   * @format binary
   */
  audio_zip_file: File;
}

/** Body_add_camera_location_api_v1_sites__site_id__add_camera_location_put */
export interface BodyAddCameraLocationApiV1SitesSiteIdAddCameraLocationPut {
  /**
   * Camera Zip File
   * @format binary
   */
  camera_zip_file: File;
}

/** Body_create_species_api_v1_species_post */
export interface BodyCreateSpeciesApiV1SpeciesPost {
  /** Common Name */
  common_name: string;
  /** Scientific Name */
  scientific_name: string;
  /** Family */
  family?: string | null;
  /** Genus */
  genus?: string | null;
  /** Taxonomy Order */
  taxonomy_order?: string | null;
  /** Description */
  description?: string | null;
  /** File */
  file?: File | null;
}

/** BulkSampleResultsCreate */
export interface BulkSampleResultsCreate {
  /**
   * Results
   * List of element results to add/update for a sample
   */
  results: SoilSampleResultCreate[];
}

/** BulkSite */
export interface BulkSite {
  /** Site Name */
  site_name: string;
  /** Centroid Wkt */
  centroid_wkt: string;
  /** Boundary */
  boundary: string;
  /**
   * Env Analysis Enabled
   * @default false
   */
  env_analysis_enabled?: boolean | null;
  /**
   * Bio Analysis Enabled
   * @default false
   */
  bio_analysis_enabled?: boolean | null;
  /**
   * Carbon Analysis Enabled
   * @default false
   */
  carbon_analysis_enabled?: boolean | null;
  /** Created At */
  created_at?: string | null;
}

/** CarbonProjectAnalysis */
export interface CarbonProjectAnalysis {
  /** Temperature */
  temperature?: number | null;
  /** Temperature Unit */
  temperature_unit?: string | null;
  /** Precipitation */
  precipitation?: number | null;
  /** Precipitation Unit */
  precipitation_unit?: string | null;
  /** Soil Type */
  soil_type?: string | null;
  /** Total Mean Biomass */
  total_mean_biomass?: number | null;
  /** Total Mean Biomass Unit */
  total_mean_biomass_unit?: string | null;
  /** Total Mean Carbon Stock */
  total_mean_carbon_stock?: number | null;
  /** Total Mean Carbon Stock Unit */
  total_mean_carbon_stock_unit?: string | null;
  /** Estimated Ghg Baseline Emissions */
  estimated_ghg_baseline_emissions?: number | null;
  /** Estimated Ghg Baseline Emissions Unit */
  estimated_ghg_baseline_emissions_unit?: string | null;
  /** Baseline Start Date */
  baseline_start_date?: number | null;
  /** Estimated Ghg Removals */
  estimated_ghg_removals?: Record<string, any> | null;
  /** Total Removals */
  total_removals?: number | null;
  /** Total Removals Unit */
  total_removals_unit?: string | null;
  /** Average Annual Removals */
  average_annual_removals?: number | null;
  /** Average Annual Removals Unit */
  average_annual_removals_unit?: string | null;
  /** Credits */
  credits?: Record<string, any> | null;
  /** Calculated At */
  calculated_at?: string | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/** CarbonSequestrationCreate */
export interface CarbonSequestrationCreate {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Age */
  age?: number | null;
  /** Height */
  height?: number | null;
  /** Diameter */
  diameter?: number | null;
  /**
   * Species
   * @default "NA"
   */
  species?: string | null;
  /** Number Of Trees Estimated */
  number_of_trees_estimated?: number | null;
}

/** CarbonSequestrationResponse */
export interface CarbonSequestrationResponse {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Age */
  age?: number | null;
  /** Height */
  height?: number | null;
  /** Diameter */
  diameter?: number | null;
  /**
   * Species
   * @default "NA"
   */
  species?: string | null;
  /** Number Of Trees Estimated */
  number_of_trees_estimated?: number | null;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Created At */
  created_at: string | null;
  /** Updated At */
  updated_at: string | null;
}

/** CarbonSiteAnalysis */
export interface CarbonSiteAnalysis {
  /** Plantation Area */
  plantation_area?: number | null;
  /** Plantation Area Unit */
  plantation_area_unit?: string | null;
  /** Planted Trees */
  planted_trees?: number | null;
  /** Lulc Timeseries */
  lulc_timeseries?: Record<string, any> | null;
  /** Lulc Transition Piechart */
  lulc_transition_piechart?: Record<string, any> | null;
  /** Surface Water Transition */
  surface_water_transition?: Record<string, any> | null;
  /** Agb */
  agb?: number | null;
  /** Agb Unit */
  agb_unit?: string | null;
  /** Mean Agb */
  mean_agb?: number | null;
  /** Mean Agb Unit */
  mean_agb_unit?: string | null;
  /** Cstock Agb */
  cstock_agb?: number | null;
  /** Cstock Agb Unit */
  cstock_agb_unit?: string | null;
  /** Mean Cstock Agb */
  mean_cstock_agb?: number | null;
  /** Mean Cstock Agb Unit */
  mean_cstock_agb_unit?: string | null;
  /** Bgb */
  bgb?: number | null;
  /** Bgb Unit */
  bgb_unit?: string | null;
  /** Mean Bgb */
  mean_bgb?: number | null;
  /** Mean Bgb Unit */
  mean_bgb_unit?: string | null;
  /** Cstock Bgb */
  cstock_bgb?: number | null;
  /** Cstock Bgb Unit */
  cstock_bgb_unit?: string | null;
  /** Mean Cstock Bgb */
  mean_cstock_bgb?: number | null;
  /** Mean Cstock Bgb Unit */
  mean_cstock_bgb_unit?: string | null;
  /** Soil Properties */
  soil_properties?: Record<string, any> | null;
  /** Soc */
  soc?: Record<string, any> | null;
  /** Agb Tif Gcs Path */
  agb_tif_gcs_path?: string | null;
  /** Calculated At */
  calculated_at?: string | null;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/**
 * ChartRequest
 * Request schema for fetching chart data.
 */
export interface ChartRequest {
  /**
   * Deploymentids
   * List of Deployment UUIDs to fetch chart data for
   */
  deploymentIds: string[];
  /**
   * Index
   * List of acoustic indices to fetch. Options:
   * - `aci`: Acoustic Complexity Index
   * - `bi`: Bioacoustic Index
   * - `adi`: Acoustic Diversity Index
   * - `aei`: Acoustic Evenness Index
   * - `ndsi`: Normalized Difference Soundscape Index
   */
  index: AcousticIndexEnum[];
}

/**
 * ChartResponse
 * Response structure for combined chart data.
 */
export interface ChartResponse {
  /** Aggregation */
  aggregation: string;
  /** Time Slots */
  time_slots: string[];
  /** Comparison */
  comparison: AppSchemasChartDeploymentComparison[];
}

/** ChronicRisks */
export interface ChronicRisks {
  /** Risk Scenarios */
  risk_scenarios: RiskScenario[];
}

/**
 * ClientNode
 * A persisted client_files row returned to the client.
 */
export interface ClientNode {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Scope */
  scope: "project" | "site";
  /** Site Id */
  site_id?: string | null;
  /** Parent Id */
  parent_id?: string | null;
  /** Node Type */
  node_type: "folder" | "file";
  /** Name */
  name: string;
  /** Gcs Path */
  gcs_path?: string | null;
  /** Content Type */
  content_type?: string | null;
  /** Size Bytes */
  size_bytes?: number | null;
  /** Uploaded By User Id */
  uploaded_by_user_id?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * ClientTreeNode
 * One node returned in the merged file-browser tree.
 */
export interface ClientTreeNode {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Node Type */
  node_type: "folder" | "file";
  /** Branch */
  branch: "custom" | "deployment";
  /** Editable */
  editable: boolean;
  /** Content Type */
  content_type?: string | null;
  /** Size Bytes */
  size_bytes?: number | null;
  /** Gcs Path */
  gcs_path?: string | null;
  /** Updated At */
  updated_at?: string | null;
  /** Scope */
  scope?: "project" | "site" | null;
  /** Site Id */
  site_id?: string | null;
  /** Parent Id */
  parent_id?: string | null;
  /** Dep Parent */
  dep_parent?: string | null;
}

/** ClientTreeResponse */
export interface ClientTreeResponse {
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Nodes */
  nodes: ClientTreeNode[];
}

/**
 * CreateFolderRequest
 * Create a folder in the writable (custom) branch.
 *
 * Folders may be anchored at the project root (scope='project') or under a
 * site (scope='site' + site_id). Nest by passing parent_id (must be a folder
 * row in the same scope).
 */
export interface CreateFolderRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Scope
   * @default "project"
   */
  scope?: "project" | "site";
  /** Site Id */
  site_id?: string | null;
  /** Parent Id */
  parent_id?: string | null;
}

/** DeploymentAdminDetail */
export interface DeploymentAdminDetail {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Describes the status of a deployment. */
  status: DeploymentStatus;
  device: DeviceAdminDetail;
  location: LocationAdminDetail;
  /** Total Files */
  total_files: number;
  /** Total Inferences */
  total_inferences: number;
}

/** DeploymentAdminDetailBase */
export interface DeploymentAdminDetailBase {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Describes the status of a deployment. */
  status: DeploymentStatus;
}

/** DeploymentAdminListDetail */
export interface DeploymentAdminListDetail {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Describes the status of a deployment. */
  status: DeploymentStatus;
  /** Project Name */
  project_name: string;
  /** Site Name */
  site_name: string;
  /** Location Name */
  location_name: string;
  /** File Count */
  file_count: number;
  /** Inference Count */
  inference_count: number;
  /** Device Name */
  device_name: string;
}

/** DeploymentCreate */
export interface DeploymentCreate {
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date?: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /**
   * Data Upload Status
   * @default false
   */
  data_upload_status?: boolean | null;
  /**
   * Is Deployment Accessible
   * @default true
   */
  is_deployment_accessible?: boolean | null;
  /** Inaccessible Photo Url */
  inaccessible_photo_url?: string | null;
  /** @default "Upcoming" */
  status?: DeploymentStatus | null;
  /** Site Id */
  site_id?: string | null;
  /** Project Id */
  project_id?: string | null;
}

/** DeploymentDetailResponse */
export interface DeploymentDetailResponse {
  deployment: DeploymentAdminDetail;
  site: Site;
  project: Project;
  location: LocationAdminDetail;
  device: DeviceAdminDetail;
}

/** DeploymentInfo */
export interface DeploymentInfo {
  /**
   * Is Predeployment Complete
   * @default false
   */
  is_predeployment_complete?: boolean | null;
  /** Flora Assessment */
  flora_assessment?: Record<string, any> | null;
  /** Fauna Assessment */
  fauna_assessment?: Record<string, any> | null;
  /** Human Activity */
  human_activity?: null;
  /** Habitat Condition */
  habitat_condition?: Record<string, any> | null;
  /** Photo Urls */
  photo_urls?: Record<string, any> | null;
  /** Device Location */
  device_location?: Record<string, any> | null;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** DeploymentInfoUpdate */
export interface DeploymentInfoUpdate {
  /**
   * Is Predeployment Complete
   * @default false
   */
  is_predeployment_complete?: boolean | null;
  /** Flora Assessment */
  flora_assessment?: Record<string, any> | null;
  /** Fauna Assessment */
  fauna_assessment?: Record<string, any> | null;
  /** Human Activity */
  human_activity?: null;
  /** Habitat Condition */
  habitat_condition?: Record<string, any> | null;
  /** Photo Urls */
  photo_urls?: Record<string, any> | null;
  /** Device Location */
  device_location?: Record<string, any> | null;
}

/** DeploymentUpdate */
export interface DeploymentUpdate {
  /** Deployment Name */
  deployment_name?: string | null;
  /** Start Date */
  start_date?: string | null;
  /** End Date */
  end_date?: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status?: boolean | null;
  /** Is Deployment Accessible */
  is_deployment_accessible?: boolean | null;
  /** Inaccessible Photo Url */
  inaccessible_photo_url?: string | null;
  status?: DeploymentStatus | null;
  /** Site Id */
  site_id?: string | null;
  /** Project Id */
  project_id?: string | null;
}

/**
 * DeveloperPermissionBulkCreate
 * Schema for bulk assigning endpoints to developer
 */
export interface DeveloperPermissionBulkCreate {
  /**
   * Endpoint Ids
   * List of endpoint IDs to assign
   */
  endpoint_ids: string[];
  /**
   * Status
   * Status for all permissions
   * @default "active"
   */
  status?: string;
}

/** DeveloperPermissionCreate */
export interface DeveloperPermissionCreate {
  /**
   * User Id
   * User ID
   * @format uuid
   */
  user_id: string;
  /**
   * Endpoint Id
   * API Endpoint ID
   * @format uuid
   */
  endpoint_id: string;
  /**
   * Status
   * Permission status: 'active' or 'inactive'
   * @default "active"
   */
  status?: string | null;
}

/**
 * DeveloperPermissionListResponse
 * Response for listing developer permissions
 */
export interface DeveloperPermissionListResponse {
  /** Permissions */
  permissions: DeveloperPermissionOut[];
  /** Count */
  count: number;
}

/** DeveloperPermissionOut */
export interface DeveloperPermissionOut {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Endpoint Id
   * @format uuid
   */
  endpoint_id: string;
  /** Status */
  status: string;
  /**
   * Granted At
   * @format date-time
   */
  granted_at: string;
  endpoint?: APIEndpointOut | null;
}

/**
 * DeveloperPermissionToggle
 * Schema for toggling permission status
 */
export interface DeveloperPermissionToggle {
  /**
   * Status
   * New status: 'active' or 'inactive'
   */
  status: string;
}

/** DeviceAdminDetail */
export interface DeviceAdminDetail {
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /** Human Readable Id */
  human_readable_id: string;
  type: DeviceType;
  /** Name */
  name: string;
  /** Purchased At */
  purchased_at?: string | null;
  /** Serial Number */
  serial_number: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /** Describes the status of a device. */
  status: DeviceStatus;
}

/** DeviceAdminDetailWithDeployment */
export interface DeviceAdminDetailWithDeployment {
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /** Human Readable Id */
  human_readable_id: string;
  type: DeviceType;
  /** Name */
  name: string;
  /** Purchased At */
  purchased_at?: string | null;
  /** Serial Number */
  serial_number: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /** Describes the status of a device. */
  status: DeviceStatus;
  /** Deployment Id */
  deployment_id?: string | null;
}

/** DeviceCreate */
export interface DeviceCreate {
  type: DeviceType;
  /** Name */
  name: string;
  /** Purchased At */
  purchased_at?: string | null;
  /** Serial Number */
  serial_number: string;
  /** @default "ACTIVE" */
  status?: DeviceStatus | null;
}

/** DeviceUpdate */
export interface DeviceUpdate {
  type?: DeviceType | null;
  /** Name */
  name?: string | null;
  /** Purchased At */
  purchased_at?: string | null;
  status?: DeviceStatus | null;
}

/** DownloadUrlResponse */
export interface DownloadUrlResponse {
  /** Download Url */
  download_url: string;
}

/** DroughtMetrics */
export interface DroughtMetrics {
  /** Days>1.0Spei */
  "days>1.0SPEI"?: number | null;
  /** Days>1.5Spei */
  "days>1.5SPEI"?: number | null;
  /** Days>2.0Spei */
  "days>2.0SPEI"?: number | null;
  /** Absolute Loss Days */
  absolute_loss_days?: number | null;
  /** Additional Loss Days */
  additional_loss_days?: number | null;
  /** Asset Damage Var Percent */
  asset_damage_var_percent?: number | null;
  /** Productivity Var Percent */
  productivity_var_percent?: number | null;
  /** Risk Category */
  risk_category?: string | null;
  /** Risk Increase Percent */
  risk_increase_percent?: number | null;
}

/** EnvironmentalProjectAnalysis */
export interface EnvironmentalProjectAnalysis {
  /** Overall Risk Score */
  overall_risk_score?: number | null;
  /** Overall Risk Category */
  overall_risk_category?: string | null;
  /** Value At Risk */
  value_at_risk?: number | null;
  chronic_risks?: ChronicRisks | null;
  /** Acute Risks */
  acute_risks?: null;
  /** Calculated At */
  calculated_at?: string | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/** EnvironmentalSiteAnalysis */
export interface EnvironmentalSiteAnalysis {
  /** Site Risk Score */
  site_risk_score?: number | null;
  /** Site Risk Category */
  site_risk_category?: string | null;
  /** Site Value At Risk */
  site_value_at_risk?: number | null;
  chronic_risks?: ChronicRisks | null;
  /** Acute Risks */
  acute_risks?: null;
  /** Calculated At */
  calculated_at?: string | null;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/** FileAdminDetail */
export interface FileAdminDetail {
  /**
   * File Id
   * @format uuid
   */
  file_id: string;
  /** Name */
  name: string;
  /** Url */
  url: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Uploaded By
   * @format uuid
   */
  uploaded_by: string;
  /** Status */
  status: string;
}

/** FileAdminDetailWithLocation */
export interface FileAdminDetailWithLocation {
  /**
   * File Id
   * @format uuid
   */
  file_id: string;
  /** Name */
  name: string;
  /** Url */
  url: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Uploaded By
   * @format uuid
   */
  uploaded_by: string;
  /** Status */
  status: string;
  location: LocationAdminDetail;
}

/** FileAdminDetailWithUser */
export interface FileAdminDetailWithUser {
  /**
   * File Id
   * @format uuid
   */
  file_id: string;
  /** Name */
  name: string;
  /** Url */
  url: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Uploaded By
   * @format uuid
   */
  uploaded_by: string;
  /** Status */
  status: string;
  uploaded_by_user: User;
  /**
   * Inferences
   * @default []
   */
  inferences?: Inference[];
}

/** FileDetail */
export interface FileDetail {
  file: FileAdminDetail;
  inference: Inference;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Project Name */
  project_name: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /** Site Name */
  site_name: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /** Location Name */
  location_name: string;
}

/** FileDetailList */
export interface FileDetailList {
  /** Total */
  total: number;
  /** Data */
  data: FileDetail[];
}

/** FileDownloadResponse */
export interface FileDownloadResponse {
  /** Download Url */
  download_url: string;
}

/** FileFinalizeRequest */
export interface FileFinalizeRequest {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Gcs Path */
  gcs_path: string;
  /** File Name */
  file_name: string;
}

/** FileUploadRequest */
export interface FileUploadRequest {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** File Name */
  file_name: string;
  /** Content Type */
  content_type: string;
}

/** FileUploadResponse */
export interface FileUploadResponse {
  /** Upload Url */
  upload_url: string;
  /** Gcs Path */
  gcs_path: string;
}

/**
 * FinalizeUploadRequest
 * Record the DB row once the browser has finished PUTting bytes to GCS.
 */
export interface FinalizeUploadRequest {
  /**
   * File Name
   * @minLength 1
   * @maxLength 255
   */
  file_name: string;
  /** Gcs Path */
  gcs_path: string;
  /** Content Type */
  content_type?: string | null;
  /**
   * Scope
   * @default "project"
   */
  scope?: "project" | "site";
  /** Site Id */
  site_id?: string | null;
  /** Parent Id */
  parent_id?: string | null;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** HeatMetrics */
export interface HeatMetrics {
  /** Days>20C */
  "days>20C"?: number | null;
  /** Days>25C */
  "days>25C"?: number | null;
  /** Days>30C */
  "days>30C"?: number | null;
  /** Days>35C */
  "days>35C"?: number | null;
  /** Absolute Loss Days */
  absolute_loss_days?: number | null;
  /** Additional Loss Days */
  additional_loss_days?: number | null;
  /** Asset Damage Var Percent */
  asset_damage_var_percent?: number | null;
  /** Productivity Var Percent */
  productivity_var_percent?: number | null;
  /** Risk Category */
  risk_category?: string | null;
  /** Risk Increase Percent */
  risk_increase_percent?: number | null;
}

/** HighValueClip */
export interface HighValueClip {
  /**
   * Common Name
   * @default "Unknown"
   */
  common_name?: string | null;
  /**
   * Scientific Name
   * @default "Unknown"
   */
  scientific_name?: string | null;
  /** Date */
  date?: string | null;
  /** Time */
  time?: string | null;
  /** Confidence */
  confidence?: number | null;
  /** Url */
  url?: string | null;
  /** File Name */
  file_name?: string | null;
  /** Seq */
  seq?: number | null;
  /** Image Url */
  image_url?: string | null;
}

/** InSituData */
export interface InSituData {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /** Acoustic Data */
  acoustic_data?: Record<string, any> | null;
  /** Activity Trend Data */
  activity_trend_data?: Record<string, any> | null;
  /** Species Count */
  species_count?: number | null;
  /** Unique Species */
  unique_species?: string[] | null;
}

/** Inference */
export interface Inference {
  /**
   * File Id
   * @format uuid
   */
  file_id: string;
  /** Data */
  data?: Record<string, any> | null;
  /** Acoustic Indices */
  acoustic_indices?: Record<string, any> | null;
  /** Spectrogram Url */
  spectrogram_url?: string | null;
  /** High Value Clip Audios */
  high_value_clip_audios?: Record<string, any>[] | null;
  /**
   * Inference Id
   * @format uuid
   */
  inference_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** InferenceUpdate */
export interface InferenceUpdate {
  /** Data */
  data?: Record<string, any> | null;
  /** High Value Clip Audios */
  high_value_clip_audios?: Record<string, any>[] | null;
}

/**
 * InitiateUploadRequest
 * Ask the server for a resumable upload session for one file.
 *
 * The server constructs the GCS path (client can't choose arbitrary paths)
 * and returns a session URI the browser PUTs bytes to. Call finalize after.
 */
export interface InitiateUploadRequest {
  /**
   * File Name
   * @minLength 1
   * @maxLength 255
   */
  file_name: string;
  /**
   * Content Type
   * @default "application/octet-stream"
   */
  content_type?: string;
  /**
   * Scope
   * @default "project"
   */
  scope?: "project" | "site";
  /** Site Id */
  site_id?: string | null;
  /** Parent Id */
  parent_id?: string | null;
}

/** InitiateUploadResponse */
export interface InitiateUploadResponse {
  /** Upload Session Uri */
  upload_session_uri: string;
  /** Gcs Path */
  gcs_path: string;
}

/** LocationAdminDetail */
export interface LocationAdminDetail {
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /** Location Name */
  location_name: string;
  /** Location */
  location: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
}

/** LocationCreate */
export interface LocationCreate {
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /** Location Name */
  location_name: string;
  /** Location */
  location: string;
}

/** LocationUpdate */
export interface LocationUpdate {
  /** Location Name */
  location_name?: string | null;
  /** Location */
  location?: string | null;
}

/** LoginRequest */
export interface LoginRequest {
  /**
   * Email
   * @format email
   */
  email: string;
  /** Password */
  password: string;
}

/** MapMarker */
export interface MapMarker {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /** Latitude */
  latitude: number;
  /** Longitude */
  longitude: number;
  /** Deployment Name */
  deployment_name: string;
  /** Status */
  status?: string | null;
  /** Device Type */
  device_type?: string | null;
  /** Site Id */
  site_id?: string | null;
  /** Site Name */
  site_name?: string | null;
}

/** NotificationCheckResult */
export interface NotificationCheckResult {
  /** Deployments Checked */
  deployments_checked: number;
  /** Notifications Sent */
  notifications_sent: number;
  /**
   * Errors
   * @default []
   */
  errors?: string[];
}

/** PluvialFloodMetrics */
export interface PluvialFloodMetrics {
  /** Max 1Day Ppt Mm */
  max_1day_ppt_mm?: number | null;
  /** Pluvial Flood Depth M */
  pluvial_flood_depth_m?: number | null;
  /** Absolute Loss Days */
  absolute_loss_days?: number | null;
  /** Additional Loss Days */
  additional_loss_days?: number | null;
  /** Asset Damage Var Percent */
  asset_damage_var_percent?: number | null;
  /** Productivity Var Percent */
  productivity_var_percent?: number | null;
  /** Risk Category */
  risk_category?: string | null;
  /** Risk Increase Percent */
  risk_increase_percent?: number | null;
}

/** PredeploymentStatusUpdate */
export interface PredeploymentStatusUpdate {
  /** Is Predeployment Complete */
  is_predeployment_complete: boolean;
}

/** Project */
export interface Project {
  /**
   * Project Name
   * @example "Mangrove Plantation Initiative"
   */
  project_name: string;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /**
   * Country
   * @example "India"
   */
  country?: string | null;
  /**
   * Project Description
   * @example "Restoring mangrove forests..."
   */
  project_description?: string | null;
  /**
   * Project Type
   * @example "ARR/WRC"
   */
  project_type?: string | null;
  /**
   * Total Area
   * @example 160.55
   */
  total_area?: number | null;
  /**
   * Area Unit
   * @default "ha"
   * @example "ha"
   */
  area_unit?: string | null;
  /**
   * Project Developer
   * @example "South Asian Forum of Environment"
   */
  project_developer?: string | null;
  /**
   * Crediting Period
   * @example "20 years"
   */
  crediting_period?: string | null;
  /**
   * Registry
   * @example "Verra"
   */
  registry?: string | null;
  /**
   * Sdg
   * @example ["sdg13.png","sdg15.png"]
   */
  sdg?: string[] | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /**
   * Owner User Id
   * @format uuid
   * @default "4898d960-60d9-4ab4-93d6-f2440f1fc7ef"
   */
  owner_user_id?: string;
  project_status: ProjectStatusEnum;
  /** Has Carbon Module */
  has_carbon_module: boolean;
  /** Has Biodiversity Module */
  has_biodiversity_module: boolean;
  /** Has Environmental Module */
  has_environmental_module: boolean;
  /** Email Notifications Enabled */
  email_notifications_enabled: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Site Count
   * @default 0
   */
  site_count?: number;
  /**
   * Is Data Room Enabled
   * @default false
   */
  is_data_room_enabled?: boolean;
}

/** ProjectAdminDetail */
export interface ProjectAdminDetail {
  /**
   * Project Name
   * @example "Mangrove Plantation Initiative"
   */
  project_name: string;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /**
   * Country
   * @example "India"
   */
  country?: string | null;
  /**
   * Project Description
   * @example "Restoring mangrove forests..."
   */
  project_description?: string | null;
  /**
   * Project Type
   * @example "ARR/WRC"
   */
  project_type?: string | null;
  /**
   * Total Area
   * @example 160.55
   */
  total_area?: number | null;
  /**
   * Area Unit
   * @default "ha"
   * @example "ha"
   */
  area_unit?: string | null;
  /**
   * Project Developer
   * @example "South Asian Forum of Environment"
   */
  project_developer?: string | null;
  /**
   * Crediting Period
   * @example "20 years"
   */
  crediting_period?: string | null;
  /**
   * Registry
   * @example "Verra"
   */
  registry?: string | null;
  /**
   * Sdg
   * @example ["sdg13.png","sdg15.png"]
   */
  sdg?: string[] | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /**
   * Owner User Id
   * @format uuid
   * @default "4898d960-60d9-4ab4-93d6-f2440f1fc7ef"
   */
  owner_user_id?: string;
  project_status: ProjectStatusEnum;
  /** Has Carbon Module */
  has_carbon_module: boolean;
  /** Has Biodiversity Module */
  has_biodiversity_module: boolean;
  /** Has Environmental Module */
  has_environmental_module: boolean;
  /** Email Notifications Enabled */
  email_notifications_enabled: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Site Count
   * @default 0
   */
  site_count?: number;
  /**
   * Is Data Room Enabled
   * @default false
   */
  is_data_room_enabled?: boolean;
  created_by: UserBase;
  /**
   * Sites
   * @default []
   */
  sites?: Site[];
}

/**
 * ProjectAdminSummary
 * Schema for summarizing project details for admin view.
 * Includes basic project information, owner, and assignment details.
 */
export interface ProjectAdminSummary {
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Project Name */
  project_name: string;
  /** Country */
  country?: string | null;
  /** Project Developer */
  project_developer?: string | null;
  /** Project Type */
  project_type?: string | null;
  project_status?: ProjectStatusEnum | null;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  created_by: UserBase;
  assignment?: Assignment | null;
}

/** ProjectCreate */
export interface ProjectCreate {
  /**
   * Project Name
   * @example "Mangrove Plantation Initiative"
   */
  project_name: string;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /**
   * Country
   * @example "India"
   */
  country?: string | null;
  /**
   * Project Description
   * @example "Restoring mangrove forests..."
   */
  project_description?: string | null;
  /**
   * Project Type
   * @example "ARR/WRC"
   */
  project_type?: string | null;
  /**
   * Total Area
   * @example 160.55
   */
  total_area?: number | null;
  /**
   * Area Unit
   * @default "ha"
   * @example "ha"
   */
  area_unit?: string | null;
  /**
   * Project Developer
   * @example "South Asian Forum of Environment"
   */
  project_developer?: string | null;
  /**
   * Crediting Period
   * @example "20 years"
   */
  crediting_period?: string | null;
  /**
   * Registry
   * @example "Verra"
   */
  registry?: string | null;
  /**
   * Sdg
   * @example ["sdg13.png","sdg15.png"]
   */
  sdg?: string[] | null;
  /** Has Carbon Module */
  has_carbon_module: boolean;
  /** Has Biodiversity Module */
  has_biodiversity_module: boolean;
  /** Has Environmental Module */
  has_environmental_module: boolean;
  /**
   * Email Notifications Enabled
   * @default false
   */
  email_notifications_enabled?: boolean;
}

/** ProjectMapData */
export interface ProjectMapData {
  /** Sites */
  sites: Site[];
  /** Locations */
  locations: LocationAdminDetail[];
  /** Deployments */
  deployments: DeploymentAdminDetailBase[];
  /** Devices */
  devices: DeviceAdminDetail[];
}

/**
 * ProjectMedia
 * Schema for returning project media to the client, includes uploader details.
 */
export interface ProjectMedia {
  /**
   * File Name
   * @example "site_photo_1.jpg"
   */
  file_name: string;
  /** Describes the type of media file. */
  media_type: MediaType;
  /**
   * Caption
   * @example "Photo of the site from the north."
   */
  caption?: string | null;
  /**
   * Media Id
   * @format uuid
   */
  media_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /**
   * Uploaded By User Id
   * @format uuid
   */
  uploaded_by_user_id: string;
  /** Gcs Path */
  gcs_path: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  uploaded_by: User;
}

/**
 * ProjectMediaDownloadResponse
 * Response schema for a generated media download URL.
 */
export interface ProjectMediaDownloadResponse {
  /** Download Url */
  download_url: string;
}

/**
 * ProjectMediaFinalizeRequest
 * Request schema for finalizing a media upload.
 */
export interface ProjectMediaFinalizeRequest {
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** File Name */
  file_name: string;
  /** Gcs Path */
  gcs_path: string;
  /** Describes the type of media file. */
  media_type: MediaType;
  /** Caption */
  caption?: string | null;
}

/**
 * ProjectMediaUpdate
 * Schema for updating a project media record, only caption is updatable.
 */
export interface ProjectMediaUpdate {
  /**
   * Caption
   * @example "A new caption for the media."
   */
  caption?: string | null;
}

/**
 * ProjectMediaUploadRequest
 * Request schema for generating a media upload URL.
 */
export interface ProjectMediaUploadRequest {
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** File Name */
  file_name: string;
  /** Content Type */
  content_type: string;
  /** Describes the type of media file. */
  media_type: MediaType;
}

/**
 * ProjectMediaUploadResponse
 * Response schema for a generated media upload URL.
 */
export interface ProjectMediaUploadResponse {
  /** Upload Url */
  upload_url: string;
  /** Gcs Path */
  gcs_path: string;
}

/** ProjectUpdate */
export interface ProjectUpdate {
  /** Project Name */
  project_name?: string | null;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /** Country */
  country?: string | null;
  /** Project Description */
  project_description?: string | null;
  /** Project Type */
  project_type?: string | null;
  /** Total Area */
  total_area?: number | null;
  /** Area Unit */
  area_unit?: string | null;
  /** Project Developer */
  project_developer?: string | null;
  /** Crediting Period */
  crediting_period?: string | null;
  /** Registry */
  registry?: string | null;
  /** Sdg */
  sdg?: string[] | null;
  /** Has Carbon Module */
  has_carbon_module?: boolean | null;
  /** Has Biodiversity Module */
  has_biodiversity_module?: boolean | null;
  /** Has Environmental Module */
  has_environmental_module?: boolean | null;
  /** Email Notifications Enabled */
  email_notifications_enabled?: boolean | null;
}

/** RetrievalInfo */
export interface RetrievalInfo {
  /** Flora Assessment */
  flora_assessment?: Record<string, any> | null;
  /** Fauna Assessment */
  fauna_assessment?: Record<string, any> | null;
  /** Human Activity */
  human_activity?: null;
  /** Photo Urls */
  photo_urls?: Record<string, any> | null;
  /** Device Condition */
  device_condition?: null;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** RetrievalInfoUpdate */
export interface RetrievalInfoUpdate {
  /** Flora Assessment */
  flora_assessment?: Record<string, any> | null;
  /** Fauna Assessment */
  fauna_assessment?: Record<string, any> | null;
  /** Human Activity */
  human_activity?: null;
  /** Photo Urls */
  photo_urls?: Record<string, any> | null;
  /** Device Condition */
  device_condition?: null;
}

/** RiskScenario */
export interface RiskScenario {
  /** Scenario */
  scenario: string;
  /** Years */
  years: Record<string, YearData>;
}

/** SectorHazards */
export interface SectorHazards {
  heat?: HeatMetrics | null;
  drought?: DroughtMetrics | null;
  pluvial_flood_rain?: PluvialFloodMetrics | null;
}

/** Site */
export interface Site {
  /**
   * Site Name
   * @example "Tipligheri"
   */
  site_name: string;
  /** Area */
  area?: number | null;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Shapefile Gcs Path */
  shapefile_gcs_path?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Boundary */
  boundary?: string | null;
  /** Centroid Wkt */
  centroid_wkt?: string | null;
  /** Carbon Analysis Status */
  carbon_analysis_status?: string | null;
  /** Env Analysis Status */
  env_analysis_status: string | null;
  /** Bio Analysis Status */
  bio_analysis_status: string | null;
  /**
   * Carbon Analysis Enabled
   * @default false
   */
  carbon_analysis_enabled?: boolean | null;
  /**
   * Bio Analysis Enabled
   * @default false
   */
  bio_analysis_enabled?: boolean | null;
  /**
   * Env Analysis Enabled
   * @default false
   */
  env_analysis_enabled?: boolean | null;
  /** Satellite Imagery */
  satellite_imagery: null;
}

/** SiteAdminDetail */
export interface SiteAdminDetail {
  /**
   * Site Name
   * @example "Tipligheri"
   */
  site_name: string;
  /** Area */
  area?: number | null;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Shapefile Gcs Path */
  shapefile_gcs_path?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Boundary */
  boundary?: string | null;
  /** Centroid Wkt */
  centroid_wkt?: string | null;
  /** Carbon Analysis Status */
  carbon_analysis_status?: string | null;
  /** Env Analysis Status */
  env_analysis_status: string | null;
  /** Bio Analysis Status */
  bio_analysis_status: string | null;
  /**
   * Carbon Analysis Enabled
   * @default false
   */
  carbon_analysis_enabled?: boolean | null;
  /**
   * Bio Analysis Enabled
   * @default false
   */
  bio_analysis_enabled?: boolean | null;
  /**
   * Env Analysis Enabled
   * @default false
   */
  env_analysis_enabled?: boolean | null;
  /** Satellite Imagery */
  satellite_imagery: null;
  /**
   * Locations
   * @default []
   */
  locations?: LocationAdminDetail[];
}

/** SiteCreate */
export interface SiteCreate {
  /**
   * Site Name
   * @example "Tipligheri"
   */
  site_name: string;
  /** Shapefile Data */
  shapefile_data?: File | string | null;
  /** Shapefile Gcs Path */
  shapefile_gcs_path?: string | null;
  /**
   * Carbon Analysis Enabled
   * @default false
   */
  carbon_analysis_enabled?: boolean | null;
  /**
   * Bio Analysis Enabled
   * @default false
   */
  bio_analysis_enabled?: boolean | null;
  /**
   * Env Analysis Enabled
   * @default false
   */
  env_analysis_enabled?: boolean | null;
  /** Area */
  area?: number | null;
  /** Boundary */
  boundary?: string | null;
  /** Centroid Wkt */
  centroid_wkt?: string | null;
}

/**
 * SiteSatelliteImagery
 * Schema for returning satellite imagery for a site.
 */
export interface SiteSatelliteImagery {
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /** Satellite Imagery */
  satellite_imagery?: null;
}

/** SiteUpdate */
export interface SiteUpdate {
  /** Site Name */
  site_name?: string | null;
  /** Area */
  area?: number | null;
  /** Shapefile Data */
  shapefile_data?: File | null;
  /** Shapefile Gcs Path */
  shapefile_gcs_path?: string | null;
  /**
   * Carbon Analysis Enabled
   * @default false
   */
  carbon_analysis_enabled?: boolean | null;
  /**
   * Bio Analysis Enabled
   * @default false
   */
  bio_analysis_enabled?: boolean | null;
  /**
   * Env Analysis Enabled
   * @default false
   */
  env_analysis_enabled?: boolean | null;
}

/** SoilElementCreate */
export interface SoilElementCreate {
  /**
   * Name
   * Element or parameter name (e.g. Organic Carbon)
   */
  name: string;
  /**
   * Symbol
   * Chemical symbol or short code (e.g. SOC)
   */
  symbol?: string | null;
  /**
   * Category
   * Category (e.g. Nutrients, Physical, Chemical)
   */
  category?: string | null;
  /**
   * Default Unit
   * Default measurement unit (e.g. %, mg/kg)
   */
  default_unit?: string | null;
  /**
   * Description
   * Detailed description of the parameter
   */
  description?: string | null;
  /**
   * Is Active
   * Whether the element is active in the catalog
   * @default true
   */
  is_active?: boolean | null;
}

/** SoilElementResponse */
export interface SoilElementResponse {
  /**
   * Name
   * Element or parameter name (e.g. Organic Carbon)
   */
  name: string;
  /**
   * Symbol
   * Chemical symbol or short code (e.g. SOC)
   */
  symbol?: string | null;
  /**
   * Category
   * Category (e.g. Nutrients, Physical, Chemical)
   */
  category?: string | null;
  /**
   * Default Unit
   * Default measurement unit (e.g. %, mg/kg)
   */
  default_unit?: string | null;
  /**
   * Description
   * Detailed description of the parameter
   */
  description?: string | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /**
   * Element Id
   * @format uuid
   */
  element_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** SoilElementUpdate */
export interface SoilElementUpdate {
  /** Name */
  name?: string | null;
  /** Symbol */
  symbol?: string | null;
  /** Category */
  category?: string | null;
  /** Default Unit */
  default_unit?: string | null;
  /** Description */
  description?: string | null;
  /** Is Active */
  is_active?: boolean | null;
}

/** SoilSampleCreate */
export interface SoilSampleCreate {
  /**
   * Sample Name
   * Descriptive name or identifier for the sample
   */
  sample_name: string;
  /**
   * Status
   * Status (e.g. Collected, In Transit, Analyzed)
   * @default "Collected"
   */
  status?: string | null;
  /**
   * Collected Date
   * Timestamp or date when sample was collected
   */
  collected_date?: string | null;
  /**
   * Soil Density
   * Soil density value
   */
  soil_density?: number | null;
  /**
   * Density Unit
   * Soil density unit
   * @default "g/cm³"
   */
  density_unit?: string | null;
  /**
   * Depth
   * Sampling depth value
   */
  depth?: number | null;
  /**
   * Depth Unit
   * Sampling depth unit
   * @default "cm"
   */
  depth_unit?: string | null;
  /**
   * Notes
   * Field notes or observations
   */
  notes?: string | null;
  /**
   * Extra Metadata
   * Extra metadata as JSON object
   */
  extra_metadata?: Record<string, any> | null;
  /**
   * Deployment Id
   * Deployment ID where sample was collected
   * @format uuid
   */
  deployment_id?: string | null;
  /**
   * Location Id
   * Location ID where sample was collected
   * @format uuid
   */
  location_id?: string | null;
  /**
   * Results
   * Optional initial results list
   */
  results?: SoilSampleResultCreate[] | null;
}

/** SoilSampleDetailResponse */
export interface SoilSampleDetailResponse {
  /**
   * Sample Name
   * Descriptive name or identifier for the sample
   */
  sample_name: string;
  /**
   * Status
   * Status (e.g. Collected, In Transit, Analyzed)
   * @default "Collected"
   */
  status?: string | null;
  /**
   * Collected Date
   * Timestamp or date when sample was collected
   */
  collected_date?: string | null;
  /**
   * Soil Density
   * Soil density value
   */
  soil_density?: number | null;
  /**
   * Density Unit
   * Soil density unit
   * @default "g/cm³"
   */
  density_unit?: string | null;
  /**
   * Depth
   * Sampling depth value
   */
  depth?: number | null;
  /**
   * Depth Unit
   * Sampling depth unit
   * @default "cm"
   */
  depth_unit?: string | null;
  /**
   * Notes
   * Field notes or observations
   */
  notes?: string | null;
  /**
   * Extra Metadata
   * Extra metadata as JSON object
   */
  extra_metadata?: Record<string, any> | null;
  /**
   * Sample Id
   * @format uuid
   */
  sample_id: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /** Site Id */
  site_id?: string | null;
  /** Project Id */
  project_id?: string | null;
  /** Location Name */
  location_name?: string | null;
  /** Site Name */
  site_name?: string | null;
  /** Project Name */
  project_name?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Results
   * @default []
   */
  results?: SoilSampleResultResponse[];
}

/** SoilSampleListResponse */
export interface SoilSampleListResponse {
  /** Total */
  total: number;
  /** Data */
  data: SoilSampleDetailResponse[];
}

/** SoilSampleResponse */
export interface SoilSampleResponse {
  /**
   * Sample Name
   * Descriptive name or identifier for the sample
   */
  sample_name: string;
  /**
   * Status
   * Status (e.g. Collected, In Transit, Analyzed)
   * @default "Collected"
   */
  status?: string | null;
  /**
   * Collected Date
   * Timestamp or date when sample was collected
   */
  collected_date?: string | null;
  /**
   * Soil Density
   * Soil density value
   */
  soil_density?: number | null;
  /**
   * Density Unit
   * Soil density unit
   * @default "g/cm³"
   */
  density_unit?: string | null;
  /**
   * Depth
   * Sampling depth value
   */
  depth?: number | null;
  /**
   * Depth Unit
   * Sampling depth unit
   * @default "cm"
   */
  depth_unit?: string | null;
  /**
   * Notes
   * Field notes or observations
   */
  notes?: string | null;
  /**
   * Extra Metadata
   * Extra metadata as JSON object
   */
  extra_metadata?: Record<string, any> | null;
  /**
   * Sample Id
   * @format uuid
   */
  sample_id: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /** Site Id */
  site_id?: string | null;
  /** Project Id */
  project_id?: string | null;
  /** Location Name */
  location_name?: string | null;
  /** Site Name */
  site_name?: string | null;
  /** Project Name */
  project_name?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** SoilSampleResultCreate */
export interface SoilSampleResultCreate {
  /**
   * Value
   * Measured numeric value
   */
  value?: number | null;
  /**
   * Unit
   * Unit of measurement
   */
  unit?: string | null;
  /**
   * Interpretation
   * Interpretation (e.g. Low, Optimal, High)
   */
  interpretation?: string | null;
  /**
   * Extra Metadata
   * Additional result metadata
   */
  extra_metadata?: Record<string, any> | null;
  /**
   * Element Id
   * ID of the soil element catalog item
   * @format uuid
   */
  element_id: string;
}

/** SoilSampleResultResponse */
export interface SoilSampleResultResponse {
  /**
   * Value
   * Measured numeric value
   */
  value?: number | null;
  /**
   * Unit
   * Unit of measurement
   */
  unit?: string | null;
  /**
   * Interpretation
   * Interpretation (e.g. Low, Optimal, High)
   */
  interpretation?: string | null;
  /**
   * Extra Metadata
   * Additional result metadata
   */
  extra_metadata?: Record<string, any> | null;
  /**
   * Result Id
   * @format uuid
   */
  result_id: string;
  /**
   * Sample Id
   * @format uuid
   */
  sample_id: string;
  /**
   * Element Id
   * @format uuid
   */
  element_id: string;
  element?: SoilElementResponse | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** SoilSampleResultUpdate */
export interface SoilSampleResultUpdate {
  /** Value */
  value?: number | null;
  /** Unit */
  unit?: string | null;
  /** Interpretation */
  interpretation?: string | null;
  /** Extra Metadata */
  extra_metadata?: Record<string, any> | null;
}

/** SoilSampleUpdate */
export interface SoilSampleUpdate {
  /** Sample Name */
  sample_name?: string | null;
  /** Status */
  status?: string | null;
  /** Collected Date */
  collected_date?: string | null;
  /** Soil Density */
  soil_density?: number | null;
  /** Density Unit */
  density_unit?: string | null;
  /** Depth */
  depth?: number | null;
  /** Depth Unit */
  depth_unit?: string | null;
  /** Notes */
  notes?: string | null;
  /** Extra Metadata */
  extra_metadata?: Record<string, any> | null;
}

/** Species */
export interface Species {
  /** Common Name */
  common_name: string;
  /** Scientific Name */
  scientific_name: string;
  /** Family */
  family: string;
  /** Genus */
  genus: string;
  /** Taxonomy Order */
  taxonomy_order: string;
  /** Image Url */
  image_url?: string | null;
  /** Description */
  description?: string | null;
  /**
   * Species Id
   * @format uuid
   */
  species_id: string;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** SpeciesDistribution */
export interface SpeciesDistribution {
  /** Critically Endangered */
  critically_endangered?: SpeciesDistributionDetail[];
  /** Endangered */
  endangered?: SpeciesDistributionDetail[];
  /** Vulnerable */
  vulnerable?: SpeciesDistributionDetail[];
  /** Near Threatened */
  near_threatened?: SpeciesDistributionDetail[];
  /** Least Concerned */
  least_concerned?: SpeciesDistributionDetail[];
  /** Unknown */
  unknown?: SpeciesDistributionDetail[];
}

/** SpeciesDistributionDetail */
export interface SpeciesDistributionDetail {
  /** Total */
  total: number;
  /** Species List */
  species_list?: string[];
}

/** SubmitBatchRequest */
export interface SubmitBatchRequest {
  /** File Ids */
  file_ids: string[];
}

/** SupportTicket */
export interface SupportTicket {
  /**
   * Ticket Id
   * @format uuid
   */
  ticket_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** User Email */
  user_email: string;
  /** User Name */
  user_name?: string | null;
  /** Subject */
  subject: string;
  /** Message */
  message: string;
  /** Category */
  category: string;
  /** Status */
  status: string;
  /** Priority */
  priority: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at: string | null;
}

/** SupportTicketCreate */
export interface SupportTicketCreate {
  /**
   * Subject
   * @minLength 5
   * @maxLength 200
   * @example "Need help with project creation"
   */
  subject: string;
  /**
   * Message
   * @minLength 10
   * @maxLength 5000
   * @example "I'm having trouble creating a new project..."
   */
  message: string;
  /** @example "Technical" */
  category: TicketCategory;
  /**
   * @default "Medium"
   * @example "Medium"
   */
  priority?: TicketPriority | null;
}

/** SupportTicketList */
export interface SupportTicketList {
  /** Tickets */
  tickets: SupportTicket[];
  /** Total */
  total: number;
  /** Skip */
  skip: number;
  /** Limit */
  limit: number;
}

/** SupportTicketUpdate */
export interface SupportTicketUpdate {
  status?: TicketStatus | null;
  priority?: TicketPriority | null;
}

/** Token */
export interface Token {
  /** Access Token */
  access_token: string;
  /** Refresh Token */
  refresh_token: string;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /**
   * Last Name
   * @default ""
   */
  last_name?: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Role */
  role: UserRole[];
  status: UserStatus;
  /** Is Email Verified */
  is_email_verified: boolean;
}

/** User */
export interface User {
  /**
   * Email
   * @format email
   * @example "user@example.com"
   */
  email: string;
  /**
   * First Name
   * @default ""
   * @example "John Doe"
   */
  first_name?: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** UserBase */
export interface UserBase {
  /**
   * Email
   * @format email
   * @example "user@example.com"
   */
  email: string;
  /**
   * First Name
   * @default ""
   * @example "John Doe"
   */
  first_name?: string;
}

/** UserCreate */
export interface UserCreate {
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * First Name
   * @default ""
   * @example "John Doe"
   */
  first_name?: string;
  /** Last Name */
  last_name: string;
  /** Password */
  password: string;
  /**
   * Tnc Checked
   * Terms and Conditions must be accepted
   * @example true
   */
  tnc_checked: boolean | null;
}

/**
 * UserCreateResponse
 * Response schema for user creation with API key
 */
export interface UserCreateResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /** Last Name */
  last_name?: string | null;
  /** Role */
  role?: string[] | null;
  /** Status */
  status?: string | null;
  /** Is Email Verified */
  is_email_verified?: boolean | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Api Key */
  api_key?: string | null;
  /** Key Prefix */
  key_prefix?: string | null;
  /** Api Key Id */
  api_key_id?: string | null;
  /** Api Key Expires At */
  api_key_expires_at?: string | null;
  /** Message */
  message: string;
}

/** UserDevice */
export interface UserDevice {
  /** Expo Push Token */
  expo_push_token: string;
  /** Platform */
  platform?: string | null;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** UserDeviceCreate */
export interface UserDeviceCreate {
  /** Expo Push Token */
  expo_push_token: string;
  /** Platform */
  platform?: string | null;
}

/**
 * UserOut
 * Schema for returning user information in API responses
 */
export interface UserOut {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /** Last Name */
  last_name?: string | null;
  /** Role */
  role?: string[] | null;
  /** Status */
  status?: string | null;
  /** Is Email Verified */
  is_email_verified?: boolean | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Api Key Id */
  api_key_id?: string | null;
  /** Api Key Expires At */
  api_key_expires_at?: string | null;
}

/** UserQueryResult */
export interface UserQueryResult {
  /** Users */
  users: AppSchemasUserUserResponse[];
  /** Count */
  count: number;
}

/** UserSignup */
export interface UserSignup {
  /**
   * Email
   * @format email
   */
  email: string;
  /** Password */
  password: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Tnc Checked
   * Terms and Conditions must be accepted
   * @example true
   */
  tnc_checked: boolean | null;
}

/** UserStatusUpdate */
export interface UserStatusUpdate {
  /**
   * Status
   * @example "Active"
   */
  status: string;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** YearData */
export interface YearData {
  /** Sectors */
  sectors: Record<string, SectorHazards>;
}

/** UserResponse */
export interface AppSchemasAuthUserResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /**
   * Last Name
   * @default ""
   */
  last_name?: string;
  /** Role */
  role: UserRole[];
  status: UserStatus;
  /** Is Email Verified */
  is_email_verified: boolean;
}

/** UserUpdate */
export interface AppSchemasAuthUserUpdate {
  /** Email */
  email?: string | null;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /**
   * Last Name
   * @default ""
   */
  last_name?: string;
  /** Password */
  password?: string | null;
}

/**
 * DeploymentComparison
 * Acoustic indices and activity trend data for a specific deployment.
 */
export interface AppSchemasChartDeploymentComparison {
  /** Deployment Id */
  deployment_id: string;
  /** Indices */
  indices: Record<string, (number | null)[]>;
  activity_trend?: ActivityTrend | null;
}

/** DeploymentComparison */
export interface AppSchemasDeploymentDataDeploymentComparison {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  deployment_info?: DeploymentInfo | null;
  retrieval_info?: RetrievalInfo | null;
}

/** UserResponse */
export interface AppSchemasUserUserResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /**
   * Last Name
   * @default ""
   */
  last_name?: string;
  /** Role */
  role: UserRole[] | null;
  /** Status */
  status: string | null;
  /** Is Email Verified */
  is_email_verified: boolean | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** UserUpdate */
export interface AppSchemasUserUserUpdate {
  /** Email */
  email?: string | null;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /**
   * Last Name
   * @default ""
   */
  last_name?: string;
  /** Role */
  role?: UserRole[] | null;
  /** Status */
  status?: string | null;
  /** Is Email Verified */
  is_email_verified?: boolean | null;
  /** Tnc Checked */
  tnc_checked?: boolean | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title MRV Backend API
 * @version 0.1.0
 *
 * API for the MRV Backend Application
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name ReadRootGet
   * @summary Read Root
   * @request GET:/
   */
  readRootGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/`,
      method: "GET",
      format: "json",
      ...params,
    });

  api = {
    /**
     * @description Basic health check endpoint. Returns a status message indicating the API is operational.
     *
     * @tags Health
     * @name HealthCheckApiV1HealthGet
     * @summary Check API Health
     * @request GET:/api/v1/health
     */
    healthCheckApiV1HealthGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/health`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create new user.
     *
     * @tags Authentication
     * @name SignupApiV1AuthSignupPost
     * @summary Signup
     * @request POST:/api/v1/auth/signup
     */
    signupApiV1AuthSignupPost: (data: UserSignup, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/auth/signup`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Send verification email to user after signup.
     *
     * @tags Authentication
     * @name SendVerificationEmailAfterSignupApiV1AuthSendVerificationEmailPostSignupPost
     * @summary Send Verification Email After Signup
     * @request POST:/api/v1/auth/send-verification-email-post-signup
     */
    sendVerificationEmailAfterSignupApiV1AuthSendVerificationEmailPostSignupPost:
      (
        query: {
          /** Email */
          email: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<any, HTTPValidationError>({
          path: `/api/v1/auth/send-verification-email-post-signup`,
          method: "POST",
          query: query,
          format: "json",
          ...params,
        }),

    /**
     * @description Verify user's email after signup.
     *
     * @tags Authentication
     * @name VerifyEmailAfterSignupApiV1AuthVerifyEmailPostSignupGet
     * @summary Verify Email After Signup
     * @request GET:/api/v1/auth/verify-email-post-signup
     */
    verifyEmailAfterSignupApiV1AuthVerifyEmailPostSignupGet: (
      query: {
        /** Token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/auth/verify-email-post-signup`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description OAuth2 compatible token login.
     *
     * @tags Authentication
     * @name LoginApiV1AuthLoginPost
     * @summary Login
     * @request POST:/api/v1/auth/login
     */
    loginApiV1AuthLoginPost: (data: LoginRequest, params: RequestParams = {}) =>
      this.request<Token, HTTPValidationError>({
        path: `/api/v1/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Test access token.
     *
     * @tags Authentication
     * @name TestTokenApiV1AuthTestTokenPost
     * @summary Test Token
     * @request POST:/api/v1/auth/test-token
     */
    testTokenApiV1AuthTestTokenPost: (params: RequestParams = {}) =>
      this.request<AppSchemasAuthUserResponse, any>({
        path: `/api/v1/auth/test-token`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Logout endpoint. Invalidates the current token by removing it from the database.
     *
     * @tags Authentication
     * @name LogoutApiV1AuthLogoutPost
     * @summary Logout
     * @request POST:/api/v1/auth/logout
     */
    logoutApiV1AuthLogoutPost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/auth/logout`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Use refresh token to get a new access token.
     *
     * @tags Authentication
     * @name RefreshTokenApiV1AuthRefreshPost
     * @summary Refresh Token
     * @request POST:/api/v1/auth/refresh
     */
    refreshTokenApiV1AuthRefreshPost: (params: RequestParams = {}) =>
      this.request<Token, any>({
        path: `/api/v1/auth/refresh`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Get current user information.
     *
     * @tags Authentication
     * @name GetUserApiV1AuthUserGet
     * @summary Get User
     * @request GET:/api/v1/auth/user
     */
    getUserApiV1AuthUserGet: (params: RequestParams = {}) =>
      this.request<AppSchemasAuthUserResponse, any>({
        path: `/api/v1/auth/user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update current user information.
     *
     * @tags Authentication
     * @name UpdateUserApiV1AuthUserPut
     * @summary Update User
     * @request PUT:/api/v1/auth/user
     */
    updateUserApiV1AuthUserPut: (
      data: AppSchemasAuthUserUpdate,
      params: RequestParams = {},
    ) =>
      this.request<AppSchemasAuthUserResponse, HTTPValidationError>({
        path: `/api/v1/auth/user`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate chart data for multiple deployments including both acoustic indices and activity trend per deployment.
     *
     * @tags Charts
     * @name CreateDeploymentChartsApiV1DeploymentsBioInsituChartPost
     * @summary Get Chart Data (Activity Trend & Acoustic Indices) for Deployments
     * @request POST:/api/v1/deployments/bio-insitu-chart
     */
    createDeploymentChartsApiV1DeploymentsBioInsituChartPost: (
      data: ChartRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChartResponse, HTTPValidationError>({
        path: `/api/v1/deployments/bio-insitu-chart`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new project. The project will be owned by the currently authenticated user. Access Control: - **Admins**: Can create projects. - **Users**: Can create projects. - **Employees**: Cannot create projects.
     *
     * @tags Projects
     * @name CreateProjectApiV1ProjectsPost
     * @summary Create a New Project
     * @request POST:/api/v1/projects/
     */
    createProjectApiV1ProjectsPost: (
      data: ProjectCreate,
      params: RequestParams = {},
    ) =>
      this.request<Project, HTTPValidationError>({
        path: `/api/v1/projects/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve projects based on the user's role. Access Control: - **Admins**: Retrieve all projects in the system. - **Employees**: Retrieve only projects they are assigned to. - **Users**: Retrieve only projects they own. - **DEV**: Retrieve only assigned projects from their organization. Authentication: - Supports both JWT Bearer token and API key (X-API-Key header or Bearer token starting with 'drk_').
     *
     * @tags Projects
     * @name ReadProjectsApiV1ProjectsGet
     * @summary List Projects by Role
     * @request GET:/api/v1/projects/
     */
    readProjectsApiV1ProjectsGet: (
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Project[], HTTPValidationError>({
        path: `/api/v1/projects/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a single project by its unique ID. Access Control: - **Admins**: Can retrieve any project. - **Employees**: Can retrieve projects they are assigned to. - **Users**: Can only retrieve projects they own. - **DEV**: Can retrieve projects assigned to them from their organization. Authentication: - Supports both JWT Bearer token and API key (X-API-Key header or Bearer token starting with 'drk_').
     *
     * @tags Projects
     * @name ReadProjectApiV1ProjectsProjectIdGet
     * @summary Get a Single Project by ID
     * @request GET:/api/v1/projects/{project_id}
     */
    readProjectApiV1ProjectsProjectIdGet: (
      projectId: string,
      query?: {
        /**
         * Get Satellite Images
         * @default false
         */
        get_satellite_images?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Project, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing project. Access Control: - **Admins**: Can update any project. - **Employees**: Can update projects they are assigned to. - **Users**: Can only update projects they own.
     *
     * @tags Projects
     * @name UpdateProjectApiV1ProjectsProjectIdPut
     * @summary Update a Project
     * @request PUT:/api/v1/projects/{project_id}
     */
    updateProjectApiV1ProjectsProjectIdPut: (
      projectId: string,
      data: ProjectUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Project, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a project. Access Control: - **Admins**: Can delete any project. - **Users**: Can only delete projects they own. - **Employees**: Cannot delete projects.
     *
     * @tags Projects
     * @name DeleteProjectApiV1ProjectsProjectIdDelete
     * @summary Delete a Project
     * @request DELETE:/api/v1/projects/{project_id}
     */
    deleteProjectApiV1ProjectsProjectIdDelete: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Get all the necessary data for the interactive map for a specific project. This includes sites, locations, deployments, and devices. The endpoint is available for projects with status "Under development".
     *
     * @tags Projects
     * @name GetProjectMapDataApiV1ProjectsProjectIdMapGet
     * @summary Get Project Data for Interactive Map
     * @request GET:/api/v1/projects/{project_id}/map
     */
    getProjectMapDataApiV1ProjectsProjectIdMapGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMapData, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/map`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get map markers (deployments) within a bounding box for a project.
     *
     * @tags Projects
     * @name GetProjectMapMarkersApiV1ProjectsProjectIdMapMarkersGet
     * @summary Get Project Map Markers via spatial bbox filter
     * @request GET:/api/v1/projects/{project_id}/map/markers
     */
    getProjectMapMarkersApiV1ProjectsProjectIdMapMarkersGet: (
      projectId: string,
      query?: {
        /**
         * Bbox
         * min_lng,min_lat,max_lng,max_lat
         */
        bbox?: string | null;
        /**
         * Device Type
         * Optional device type category filter
         */
        device_type?: string | null;
        /**
         *  T
         * Cache buster timestamp
         */
        _t?: number | null;
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @default 500
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MapMarker[], HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/map/markers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all field photos (deployment_info, retrieval_info, inaccessible photos, and attached image files) for all deployments belonging to a project, with secure presigned download URLs.
     *
     * @tags Projects
     * @name GetProjectDeploymentMediaApiApiV1ProjectsProjectIdDeploymentMediaGet
     * @summary Get All Deployment & Retrieval Photos for a Project
     * @request GET:/api/v1/projects/{project_id}/deployment-media
     */
    getProjectDeploymentMediaApiApiV1ProjectsProjectIdDeploymentMediaGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/deployment-media`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create multiple sites for a project in a single bulk operation. Access Control: - Requires write access to the parent project (Admin, assigned Employee, or Owner).
     *
     * @tags Sites
     * @name CreateBulkSiteApiV1ProjectsProjectIdSitesBulkPost
     * @summary Create Multiple Sites for a Project
     * @request POST:/api/v1/projects/{project_id}/sites/bulk
     */
    createBulkSiteApiV1ProjectsProjectIdSitesBulkPost: (
      projectId: string,
      data: BulkSite[],
      params: RequestParams = {},
    ) =>
      this.request<Site[], HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/sites/bulk`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new site within a specific project. If shapefile data is provided, it will be uploaded and processed asynchronously. Access Control: - **Admins**: Can create a site in any project. - **Employees**: Can create a site in projects they are assigned to. - **Users**: Can only create a site in projects they own.
     *
     * @tags Sites
     * @name CreateSiteApiV1ProjectsProjectIdSitesPost
     * @summary Create a New Site
     * @request POST:/api/v1/projects/{project_id}/sites
     */
    createSiteApiV1ProjectsProjectIdSitesPost: (
      projectId: string,
      data: SiteCreate,
      params: RequestParams = {},
    ) =>
      this.request<Site, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/sites`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all sites belonging to a specific project. Access Control: - **Admins**: Can list sites for any project. - **Employees**: Can list sites for projects they are assigned to. - **Users**: Can only list sites for projects they own. - **DEV**: Can list sites for assigned projects.
     *
     * @tags Sites
     * @name ReadSitesForProjectApiV1ProjectsProjectIdSitesGet
     * @summary List All Sites for a Project
     * @request GET:/api/v1/projects/{project_id}/sites
     */
    readSitesForProjectApiV1ProjectsProjectIdSitesGet: (
      projectId: string,
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Site[], HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/sites`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get satellite imagery for multiple sites in a single request. More efficient than loading one by one.
     *
     * @tags Sites
     * @name GetBatchSatelliteImageryApiV1SitesSatelliteImageryBatchPost
     * @summary Get Satellite Imagery for Multiple Sites
     * @request POST:/api/v1/sites/satellite-imagery/batch
     */
    getBatchSatelliteImageryApiV1SitesSatelliteImageryBatchPost: (
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<SiteSatelliteImagery[], HTTPValidationError>({
        path: `/api/v1/sites/satellite-imagery/batch`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing site's properties. Access Control: - **Admins**: Can update any site. - **Employees**: Can update sites in projects they are assigned to. - **Users**: Can only update sites in projects they own.
     *
     * @tags Sites
     * @name UpdateSiteApiV1SitesSiteIdPatch
     * @summary Update a Site
     * @request PATCH:/api/v1/sites/{site_id}
     */
    updateSiteApiV1SitesSiteIdPatch: (
      siteId: string,
      data: SiteUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Site, HTTPValidationError>({
        path: `/api/v1/sites/${siteId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a specific site by its unique ID. Access Control: - **Admins**: Can retrieve any site. - **Employees**: Can retrieve sites in projects they are assigned to. - **Users**: Can only retrieve sites in projects they own. - **DEV**: Can retrieve assigned sites.
     *
     * @tags Sites
     * @name ReadSiteApiV1SitesSiteIdGet
     * @summary Get a Single Site by ID
     * @request GET:/api/v1/sites/{site_id}
     */
    readSiteApiV1SitesSiteIdGet: (siteId: string, params: RequestParams = {}) =>
      this.request<Site, HTTPValidationError>({
        path: `/api/v1/sites/${siteId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a site and its associated data. Access Control: - **Admins**: Can delete any site. - **Employees**: Can delete sites in projects they are assigned to. - **Users**: Can only delete sites in projects they own.
     *
     * @tags Sites
     * @name DeleteSiteApiV1SitesSiteIdDelete
     * @summary Delete a Site
     * @request DELETE:/api/v1/sites/{site_id}
     */
    deleteSiteApiV1SitesSiteIdDelete: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/sites/${siteId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Upload camera location data (zip file) for a specific site. Access Control: - **Admins**: Can add data to any site. - **Employees**: Can add data to sites in projects they are assigned to. - **Users**: Can only add data to sites in projects they own.
     *
     * @tags Sites
     * @name AddCameraLocationApiV1SitesSiteIdAddCameraLocationPut
     * @summary Add Camera Location Data to a Site
     * @request PUT:/api/v1/sites/{site_id}/add-camera-location
     */
    addCameraLocationApiV1SitesSiteIdAddCameraLocationPut: (
      siteId: string,
      data: BodyAddCameraLocationApiV1SitesSiteIdAddCameraLocationPut,
      params: RequestParams = {},
    ) =>
      this.request<Site, HTTPValidationError>({
        path: `/api/v1/sites/${siteId}/add-camera-location`,
        method: "PUT",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload audio location data (zip file) for a specific site. Access Control: - **Admins**: Can add data to any site. - **Employees**: Can add data to sites in projects they are assigned to. - **Users**: Can only add data to sites in projects they own.
     *
     * @tags Sites
     * @name AddAudioLocationApiV1SitesSiteIdAddAudioLocationPut
     * @summary Add Audio Location Data to a Site
     * @request PUT:/api/v1/sites/{site_id}/add-audio-location
     */
    addAudioLocationApiV1SitesSiteIdAddAudioLocationPut: (
      siteId: string,
      data: BodyAddAudioLocationApiV1SitesSiteIdAddAudioLocationPut,
      params: RequestParams = {},
    ) =>
      this.request<Site, HTTPValidationError>({
        path: `/api/v1/sites/${siteId}/add-audio-location`,
        method: "PUT",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve the Carbon Analysis summary for a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own.
     *
     * @tags Analysis (Carbon)
     * @name ReadCarbonProjectSummaryApiV1ProjectsProjectIdCarbonSummaryGet
     * @summary Get Carbon Analysis Summary for a Project
     * @request GET:/api/v1/projects/{project_id}/carbon/summary
     */
    readCarbonProjectSummaryApiV1ProjectsProjectIdCarbonSummaryGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<CarbonProjectAnalysis, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/carbon/summary`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve Carbon Analysis details for a specific site. Access Control: - **Admins**: Can access analysis for any site. - **Employees**: Can access analysis for sites in projects they are assigned to. - **Users**: Can only access analysis for sites in projects they own.
     *
     * @tags Analysis (Carbon)
     * @name ReadCarbonSiteDetailsApiV1SitesSiteIdCarbonGet
     * @summary Get Carbon Analysis for a Site
     * @request GET:/api/v1/sites/{site_id}/carbon
     */
    readCarbonSiteDetailsApiV1SitesSiteIdCarbonGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<CarbonSiteAnalysis, HTTPValidationError>({
        path: `/api/v1/sites/${siteId}/carbon`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve Carbon Analysis details for all sites within a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own.
     *
     * @tags Analysis (Carbon)
     * @name ReadCarbonAllSitesForProjectApiV1ProjectsProjectIdCarbonSitesGet
     * @summary Get Carbon Analysis for All Sites in a Project
     * @request GET:/api/v1/projects/{project_id}/carbon/sites
     */
    readCarbonAllSitesForProjectApiV1ProjectsProjectIdCarbonSitesGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<CarbonSiteAnalysis[], HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/carbon/sites`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve the Biodiversity Analysis summary for a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own. - **DEV**: Can access analysis for projects assigned to them from their organization.
     *
     * @tags Analysis (Biodiversity)
     * @name ReadBiodiversityProjectSummaryApiV1ProjectsProjectIdBiodiversitySummaryGet
     * @summary Get Biodiversity Analysis Summary for a Project
     * @request GET:/api/v1/projects/{project_id}/biodiversity/summary
     */
    readBiodiversityProjectSummaryApiV1ProjectsProjectIdBiodiversitySummaryGet:
      (projectId: string, params: RequestParams = {}) =>
        this.request<BiodiversityProjectAnalysis, HTTPValidationError>({
          path: `/api/v1/projects/${projectId}/biodiversity/summary`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve Biodiversity Analysis details for a specific site. Access Control: - **Admins**: Can access analysis for any site. - **Employees**: Can access analysis for sites in projects they are assigned to. - **Users**: Can only access analysis for sites in projects they own. - **DEV**: Can access analysis for sites in projects assigned to them.
     *
     * @tags Analysis (Biodiversity)
     * @name ReadBiodiversitySiteDetailsApiV1SitesSiteIdBiodiversityGet
     * @summary Get Biodiversity Analysis for a Site
     * @request GET:/api/v1/sites/{site_id}/biodiversity
     */
    readBiodiversitySiteDetailsApiV1SitesSiteIdBiodiversityGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<BiodiversitySiteAnalysis, HTTPValidationError>({
        path: `/api/v1/sites/${siteId}/biodiversity`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve Biodiversity Analysis details for all sites within a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own. - **DEV**: Can access analysis for projects assigned to them.
     *
     * @tags Analysis (Biodiversity)
     * @name ReadBiodiversityAllSitesForProjectApiV1ProjectsProjectIdBiodiversitySitesGet
     * @summary Get Biodiversity Analysis for All Sites in a Project
     * @request GET:/api/v1/projects/{project_id}/biodiversity/sites
     */
    readBiodiversityAllSitesForProjectApiV1ProjectsProjectIdBiodiversitySitesGet:
      (projectId: string, params: RequestParams = {}) =>
        this.request<BiodiversitySiteAnalysis[], HTTPValidationError>({
          path: `/api/v1/projects/${projectId}/biodiversity/sites`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve the in-situ species conservation status distribution for a project. Behavior: - Validate user authorization and project access. - Ensure biodiversity module is enabled for the project. - Attempt to fetch precomputed in-situ species distribution from BiodiversityProjectAnalysis table. - If distribution exists, return the stored value. - If not stored, compute the distribution dynamically from available in-situ summaries (without persisting it).
     *
     * @tags Analysis (Biodiversity)
     * @name ReadBiodiversityInsituSummaryApiV1ProjectsProjectIdBiodiversityInsituSummaryGet
     * @summary Get In-situ Species Distribution for a Project
     * @request GET:/api/v1/projects/{project_id}/biodiversity/insitu-summary
     */
    readBiodiversityInsituSummaryApiV1ProjectsProjectIdBiodiversityInsituSummaryGet:
      (projectId: string, params: RequestParams = {}) =>
        this.request<SpeciesDistribution, HTTPValidationError>({
          path: `/api/v1/projects/${projectId}/biodiversity/insitu-summary`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve the in-situ species conservation status distribution for a site. Behavior: - Validate user authorization and site access. - Ensure biodiversity module is enabled for the parent project. - Attempt to fetch precomputed in-situ species distribution from BiodiversitySiteAnalysis table. - If distribution exists, return the stored value. - If not stored, compute the distribution dynamically from available in-situ summaries (without persisting it).
     *
     * @tags Analysis (Biodiversity)
     * @name ReadBiodiversityInsituSummaryForSiteApiV1SitesSiteIdBiodiversityInsituSummaryGet
     * @summary Get In-situ Species Distribution for a Site
     * @request GET:/api/v1/sites/{site_id}/biodiversity/insitu-summary
     */
    readBiodiversityInsituSummaryForSiteApiV1SitesSiteIdBiodiversityInsituSummaryGet:
      (siteId: string, params: RequestParams = {}) =>
        this.request<SpeciesDistribution, HTTPValidationError>({
          path: `/api/v1/sites/${siteId}/biodiversity/insitu-summary`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve top audio clips for a project grouped by species. Behavior: - Fetch all high-value clips for the project. - Normalize clip fields. - Group clips by scientific_name (species string). - For each species, sort clips by confidence (desc) and return up to 10 clips.
     *
     * @tags Analysis (Biodiversity)
     * @name GetTopUniqueSpeciesClipsApiV1ProjectsProjectIdBiodiversityAudioClipsGet
     * @summary Get Top 10 Unique Species Audio Clips for a Project
     * @request GET:/api/v1/projects/{project_id}/biodiversity/audio-clips
     */
    getTopUniqueSpeciesClipsApiV1ProjectsProjectIdBiodiversityAudioClipsGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, HighValueClip[]>, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/biodiversity/audio-clips`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve the top 10 high-value audio clips for a site.
     *
     * @tags Analysis (Biodiversity)
     * @name GetSiteTopUniqueSpeciesClipsApiV1SitesSiteIdBiodiversityAudioClipsGet
     * @summary Get Top 10 Unique Species Audio Clips for a Site
     * @request GET:/api/v1/sites/{site_id}/biodiversity/audio-clips
     */
    getSiteTopUniqueSpeciesClipsApiV1SitesSiteIdBiodiversityAudioClipsGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, HighValueClip[]>, HTTPValidationError>({
        path: `/api/v1/sites/${siteId}/biodiversity/audio-clips`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve the top 10 high-value audio clips for a deployment. Accessible by any user, constrained to users assigned to this project (or Admin / Owner).
     *
     * @tags Analysis (Biodiversity)
     * @name GetDeploymentTopUniqueSpeciesClipsApiV1DeploymentsDeploymentIdBiodiversityAudioClipsGet
     * @summary Get Top 10 Unique Species Audio Clips for a Deployment
     * @request GET:/api/v1/deployments/{deployment_id}/biodiversity/audio-clips
     */
    getDeploymentTopUniqueSpeciesClipsApiV1DeploymentsDeploymentIdBiodiversityAudioClipsGet:
      (deploymentId: string, params: RequestParams = {}) =>
        this.request<Record<string, HighValueClip[]>, HTTPValidationError>({
          path: `/api/v1/deployments/${deploymentId}/biodiversity/audio-clips`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve the Environmental Analysis summary for a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own. - **DEV**: Can access analysis for projects assigned to them.
     *
     * @tags Analysis (Environmental)
     * @name ReadEnvironmentalProjectSummaryApiV1ProjectsProjectIdEnvironmentalSummaryGet
     * @summary Get Environmental Analysis Summary for a Project
     * @request GET:/api/v1/projects/{project_id}/environmental/summary
     */
    readEnvironmentalProjectSummaryApiV1ProjectsProjectIdEnvironmentalSummaryGet:
      (projectId: string, params: RequestParams = {}) =>
        this.request<EnvironmentalProjectAnalysis, HTTPValidationError>({
          path: `/api/v1/projects/${projectId}/environmental/summary`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve Environmental Analysis details for a specific site. Access Control: - **Admins**: Can access analysis for any site. - **Employees**: Can access analysis for sites in projects they are assigned to. - **Users**: Can only access analysis for sites in projects they own. - **DEV**: Can access analysis for sites in projects assigned to them.
     *
     * @tags Analysis (Environmental)
     * @name ReadEnvironmentalSiteDetailsApiV1SitesSiteIdEnvironmentalGet
     * @summary Get Environmental Analysis for a Site
     * @request GET:/api/v1/sites/{site_id}/environmental
     */
    readEnvironmentalSiteDetailsApiV1SitesSiteIdEnvironmentalGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<EnvironmentalSiteAnalysis, HTTPValidationError>({
        path: `/api/v1/sites/${siteId}/environmental`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve Environmental Analysis details for all sites within a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own. - **DEV**: Can access analysis for projects assigned to them.
     *
     * @tags Analysis (Environmental)
     * @name ReadEnvironmentalAllSitesForProjectApiV1ProjectsProjectIdEnvironmentalSitesGet
     * @summary Get Environmental Analysis for All Sites in a Project
     * @request GET:/api/v1/projects/{project_id}/environmental/sites
     */
    readEnvironmentalAllSitesForProjectApiV1ProjectsProjectIdEnvironmentalSitesGet:
      (projectId: string, params: RequestParams = {}) =>
        this.request<EnvironmentalSiteAnalysis[], HTTPValidationError>({
          path: `/api/v1/projects/${projectId}/environmental/sites`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Request a password reset link to be sent to the user's email.
     *
     * @tags Password
     * @name RequestPasswordResetApiV1RequestPasswordResetGet
     * @summary Request Password Reset
     * @request GET:/api/v1/request-password-reset
     */
    requestPasswordResetApiV1RequestPasswordResetGet: (
      query: {
        /** Email */
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/request-password-reset`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Verify that the password reset token is valid and not expired.
     *
     * @tags Password
     * @name VerifyPasswordResetLinkApiV1VerifyPasswordLinkPost
     * @summary Verify Password Reset Link
     * @request POST:/api/v1/verify-password-link
     */
    verifyPasswordResetLinkApiV1VerifyPasswordLinkPost: (
      query: {
        /** Token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/verify-password-link`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * @description Reset the user's password using a valid password reset token.
     *
     * @tags Password
     * @name ResetUserPasswordApiV1ResetPasswordPost
     * @summary Reset User Password
     * @request POST:/api/v1/reset-password
     */
    resetUserPasswordApiV1ResetPasswordPost: (
      query: {
        /** Token */
        token: string;
        /** New Password */
        new_password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/reset-password`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of projects for the admin dashboard. Access Control: - **Admins**: Retrieve all projects in the system. - **Employees**: Retrieve only projects they are assigned to.
     *
     * @tags Admin (Projects)
     * @name GetAllProjectsAdminApiV1AdminProjectsGet
     * @summary List Projects (Admin/Employee)
     * @request GET:/api/v1/admin/projects
     */
    getAllProjectsAdminApiV1AdminProjectsGet: (params: RequestParams = {}) =>
      this.request<ProjectAdminSummary[], any>({
        path: `/api/v1/admin/projects`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve detailed information for a specific project, including its sites. Access Control: - **Admins / Employees**: Can retrieve details for any project they have access to view.
     *
     * @tags Admin (Projects)
     * @name GetProjectDetailsAdminApiV1AdminProjectsProjectIdGet
     * @summary Get Project Details (Admin/Employee)
     * @request GET:/api/v1/admin/projects/{project_id}
     */
    getProjectDetailsAdminApiV1AdminProjectsProjectIdGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectAdminDetail, HTTPValidationError>({
        path: `/api/v1/admin/projects/${projectId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update project details from the admin interface.
     *
     * @tags Admin (Projects)
     * @name UpdateProjectAdminApiV1AdminProjectsProjectIdPatch
     * @summary Update Project details (Admin/Employee)
     * @request PATCH:/api/v1/admin/projects/{project_id}
     */
    updateProjectAdminApiV1AdminProjectsProjectIdPatch: (
      projectId: string,
      data: ProjectUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ProjectAdminDetail, HTTPValidationError>({
        path: `/api/v1/admin/projects/${projectId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve detailed information for a specific site, including locations and deployments. Access Control: - **Admins / Employees**: Can retrieve details for any site they have access to view.
     *
     * @tags Admin (Sites)
     * @name GetSiteDetailsAdminApiV1AdminSitesSiteIdGet
     * @summary Get Site Details (Admin/Employee)
     * @request GET:/api/v1/admin/sites/{site_id}
     */
    getSiteDetailsAdminApiV1AdminSitesSiteIdGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteAdminDetail, HTTPValidationError>({
        path: `/api/v1/admin/sites/${siteId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve details of a specific deployment, including files, site, and project. Access Control: - **Admins / Employees**: Can retrieve details for any deployment they have access to view. - **Field Workers**: Can retrieve details for any deployment they have access to view.
     *
     * @tags Admin (Deployments)
     * @name GetDeploymentDetailsAdminApiV1AdminDeploymentsDeploymentIdGet
     * @summary Get Deployment Details (Admin/Employee/FieldWorker)
     * @request GET:/api/v1/admin/deployments/{deployment_id}
     */
    getDeploymentDetailsAdminApiV1AdminDeploymentsDeploymentIdGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentDetailResponse, HTTPValidationError>({
        path: `/api/v1/admin/deployments/${deploymentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing deployment record. Access Control: - Admins and Employees can update all fields. - FieldWorkers can only update status to 'Deployed' or 'Retrieved'.
     *
     * @tags Admin (Deployments)
     * @name UpdateApiDeploymentApiV1AdminDeploymentsDeploymentIdPut
     * @summary Update a Deployment (Admin/Employee/FieldWorker)
     * @request PUT:/api/v1/admin/deployments/{deployment_id}
     */
    updateApiDeploymentApiV1AdminDeploymentsDeploymentIdPut: (
      deploymentId: string,
      data: DeploymentUpdate,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentAdminDetailBase, HTTPValidationError>({
        path: `/api/v1/admin/deployments/${deploymentId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a deployment and all its children. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Deployments)
     * @name DeleteApiDeploymentApiV1AdminDeploymentsDeploymentIdDelete
     * @summary Delete a Deployment (Admin/Employee)
     * @request DELETE:/api/v1/admin/deployments/{deployment_id}
     */
    deleteApiDeploymentApiV1AdminDeploymentsDeploymentIdDelete: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/admin/deployments/${deploymentId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve a list of all deployments with detailed information. Access Control: - **Admins**: Retrieve all deployments in the system. - **Employees**: Retrieve only deployments from projects they are assigned to. - **Users**: Retrieve only deployments from projects they created.
     *
     * @tags Admin (Deployments)
     * @name GetAllDeploymentsApiV1AdminDeploymentsGet
     * @summary List All Deployments (Admin/Employee)
     * @request GET:/api/v1/admin/deployments
     */
    getAllDeploymentsApiV1AdminDeploymentsGet: (params: RequestParams = {}) =>
      this.request<DeploymentAdminListDetail[], any>({
        path: `/api/v1/admin/deployments`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new deployment record. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Deployments)
     * @name CreateApiDeploymentApiV1AdminDeploymentsPost
     * @summary Create a New Deployment (Admin/Employee)
     * @request POST:/api/v1/admin/deployments
     */
    createApiDeploymentApiV1AdminDeploymentsPost: (
      data: DeploymentCreate,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentAdminDetailBase, HTTPValidationError>({
        path: `/api/v1/admin/deployments`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create or partial update deployment info.
     *
     * @tags Admin (Deployments)
     * @name CreateOrUpdateDeploymentInfoApiApiV1AdminDeploymentsDeploymentIdInfoPost
     * @summary Create or Update Deployment Info
     * @request POST:/api/v1/admin/deployments/{deployment_id}/info
     */
    createOrUpdateDeploymentInfoApiApiV1AdminDeploymentsDeploymentIdInfoPost: (
      deploymentId: string,
      data: DeploymentInfoUpdate,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentInfo, HTTPValidationError>({
        path: `/api/v1/admin/deployments/${deploymentId}/info`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve info for a specific deployment.
     *
     * @tags Admin (Deployments)
     * @name GetDeploymentInfoApiApiV1AdminDeploymentsDeploymentIdInfoGet
     * @summary Get Deployment Info (Admin/Employee/FieldWorker)
     * @request GET:/api/v1/admin/deployments/{deployment_id}/info
     */
    getDeploymentInfoApiApiV1AdminDeploymentsDeploymentIdInfoGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentInfo, HTTPValidationError>({
        path: `/api/v1/admin/deployments/${deploymentId}/info`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update only the is_predeployment_complete flag.
     *
     * @tags Admin (Deployments)
     * @name UpdatePredeploymentStatusApiApiV1AdminDeploymentsDeploymentIdPredeploymentStatusPatch
     * @summary Update Pre-deployment Completion Status
     * @request PATCH:/api/v1/admin/deployments/{deployment_id}/predeployment-status
     */
    updatePredeploymentStatusApiApiV1AdminDeploymentsDeploymentIdPredeploymentStatusPatch:
      (
        deploymentId: string,
        data: PredeploymentStatusUpdate,
        params: RequestParams = {},
      ) =>
        this.request<DeploymentInfo, HTTPValidationError>({
          path: `/api/v1/admin/deployments/${deploymentId}/predeployment-status`,
          method: "PATCH",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Create or update retrieval info for a deployment.
     *
     * @tags Admin (Deployments)
     * @name CreateOrUpdateRetrievalInfoApiApiV1AdminDeploymentsDeploymentIdRetrievalPost
     * @summary Create or Update Retrieval Info
     * @request POST:/api/v1/admin/deployments/{deployment_id}/retrieval
     */
    createOrUpdateRetrievalInfoApiApiV1AdminDeploymentsDeploymentIdRetrievalPost:
      (
        deploymentId: string,
        data: RetrievalInfoUpdate,
        params: RequestParams = {},
      ) =>
        this.request<RetrievalInfo, HTTPValidationError>({
          path: `/api/v1/admin/deployments/${deploymentId}/retrieval`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve retrieval data for a specific deployment.
     *
     * @tags Admin (Deployments)
     * @name GetRetrievalInfoApiApiV1AdminDeploymentsDeploymentIdRetrievalGet
     * @summary Get Retrieval Info (Admin/Employee/FieldWorker)
     * @request GET:/api/v1/admin/deployments/{deployment_id}/retrieval
     */
    getRetrievalInfoApiApiV1AdminDeploymentsDeploymentIdRetrievalGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<RetrievalInfo, HTTPValidationError>({
        path: `/api/v1/admin/deployments/${deploymentId}/retrieval`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve both deployment and retrieval info side-by-side for comparison.
     *
     * @tags Admin (Deployments)
     * @name GetDeploymentComparisonApiApiV1AdminDeploymentsDeploymentIdComparisonGet
     * @summary Get Deployment vs Retrieval Comparison (Admin/Employee/FieldWorker)
     * @request GET:/api/v1/admin/deployments/{deployment_id}/comparison
     */
    getDeploymentComparisonApiApiV1AdminDeploymentsDeploymentIdComparisonGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDataDeploymentComparison,
        HTTPValidationError
      >({
        path: `/api/v1/admin/deployments/${deploymentId}/comparison`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a secure signed URL for assessment photos (deployment/retrieval). The server constructs the GCS path to prevent unauthorized bucket access.
     *
     * @tags Admin (Deployments)
     * @name GetAssessmentMediaSignedUrlApiApiV1AdminDeploymentsDeploymentIdAssessmentMediaUrlPost
     * @summary Generate Secure Presigned URL for Assessment Media
     * @request POST:/api/v1/admin/deployments/{deployment_id}/assessment-media-url
     */
    getAssessmentMediaSignedUrlApiApiV1AdminDeploymentsDeploymentIdAssessmentMediaUrlPost:
      (
        deploymentId: string,
        data: AssessmentMediaUploadRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, HTTPValidationError>({
          path: `/api/v1/admin/deployments/${deploymentId}/assessment-media-url`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Generate a secure signed URL for downloading/viewing assessment photos.
     *
     * @tags Admin (Deployments)
     * @name GetAssessmentMediaDownloadUrlApiApiV1AdminDeploymentsDeploymentIdAssessmentMediaDownloadUrlPost
     * @summary Generate Secure Presigned Download URL for Assessment Media
     * @request POST:/api/v1/admin/deployments/{deployment_id}/assessment-media-download-url
     */
    getAssessmentMediaDownloadUrlApiApiV1AdminDeploymentsDeploymentIdAssessmentMediaDownloadUrlPost:
      (
        deploymentId: string,
        data: AssessmentMediaDownloadRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, HTTPValidationError>({
          path: `/api/v1/admin/deployments/${deploymentId}/assessment-media-download-url`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve all deployments for a specific location. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Deployments)
     * @name GetDeploymentsByLocationIdApiV1AdminLocationsLocationIdDeploymentsGet
     * @summary List Deployments for a Location (Admin/Employee/FieldWorker)
     * @request GET:/api/v1/admin/locations/{location_id}/deployments
     */
    getDeploymentsByLocationIdApiV1AdminLocationsLocationIdDeploymentsGet: (
      locationId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentAdminDetail[], HTTPValidationError>({
        path: `/api/v1/admin/locations/${locationId}/deployments`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new location within a site. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Locations)
     * @name CreateApiLocationApiV1AdminLocationsPost
     * @summary Create a New Location (Admin/Employee)
     * @request POST:/api/v1/admin/locations
     */
    createApiLocationApiV1AdminLocationsPost: (
      data: LocationCreate,
      params: RequestParams = {},
    ) =>
      this.request<LocationAdminDetail, HTTPValidationError>({
        path: `/api/v1/admin/locations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing location. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Locations)
     * @name UpdateApiLocationApiV1AdminLocationsLocationIdPut
     * @summary Update a Location (Admin/Employee)
     * @request PUT:/api/v1/admin/locations/{location_id}
     */
    updateApiLocationApiV1AdminLocationsLocationIdPut: (
      locationId: string,
      data: LocationUpdate,
      params: RequestParams = {},
    ) =>
      this.request<LocationAdminDetail, HTTPValidationError>({
        path: `/api/v1/admin/locations/${locationId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a location and all its children (deployments). Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Locations)
     * @name DeleteApiLocationApiV1AdminLocationsLocationIdDelete
     * @summary Delete a Location (Admin/Employee)
     * @request DELETE:/api/v1/admin/locations/{location_id}
     */
    deleteApiLocationApiV1AdminLocationsLocationIdDelete: (
      locationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/admin/locations/${locationId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve all devices in the system. For each device, add deployment_id if the device is in an active deployment. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Devices)
     * @name GetAllDevicesAdminApiV1AdminDevicesGet
     * @summary List All Devices (Admin/Employee)
     * @request GET:/api/v1/admin/devices
     */
    getAllDevicesAdminApiV1AdminDevicesGet: (params: RequestParams = {}) =>
      this.request<DeviceAdminDetailWithDeployment[], any>({
        path: `/api/v1/admin/devices`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new device record. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Devices)
     * @name CreateApiDeviceApiV1AdminDevicesPost
     * @summary Create a New Device (Admin/Employee)
     * @request POST:/api/v1/admin/devices
     */
    createApiDeviceApiV1AdminDevicesPost: (
      data: DeviceCreate,
      params: RequestParams = {},
    ) =>
      this.request<DeviceAdminDetail, HTTPValidationError>({
        path: `/api/v1/admin/devices`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing device record. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Devices)
     * @name UpdateApiDeviceApiV1AdminDevicesDeviceIdPut
     * @summary Update a Device (Admin/Employee)
     * @request PUT:/api/v1/admin/devices/{device_id}
     */
    updateApiDeviceApiV1AdminDevicesDeviceIdPut: (
      deviceId: string,
      data: DeviceUpdate,
      params: RequestParams = {},
    ) =>
      this.request<DeviceAdminDetail, HTTPValidationError>({
        path: `/api/v1/admin/devices/${deviceId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retire a device record by setting its status to 'RETIRED'. This preserves the device's data for historical purposes instead of permanent deletion. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Devices)
     * @name DeleteApiDeviceApiV1AdminDevicesDeviceIdDelete
     * @summary Retire a Device (Admin/Employee)
     * @request DELETE:/api/v1/admin/devices/{device_id}
     */
    deleteApiDeviceApiV1AdminDevicesDeviceIdDelete: (
      deviceId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/admin/devices/${deviceId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Generate a signed URL for uploading a file to Google Cloud Storage. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name GenerateUploadUrlApiV1AdminFilesGenerateUploadUrlPost
     * @summary Generate GCS Upload URL (Admin/Employee)
     * @request POST:/api/v1/admin/files/generate-upload-url
     */
    generateUploadUrlApiV1AdminFilesGenerateUploadUrlPost: (
      data: FileUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileUploadResponse, HTTPValidationError>({
        path: `/api/v1/admin/files/generate-upload-url`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finalize a file upload: - Synchronously create the file record. - Run deployment/location lookup, lat/lon decoding, inference, spectrogram, and acoustic metrics in a background task.
     *
     * @tags Admin (Files)
     * @name FinalizeUploadApiV1AdminFilesFinalizeUploadPost
     * @summary Finalize File Upload (Admin/Employee)
     * @request POST:/api/v1/admin/files/finalize-upload
     */
    finalizeUploadApiV1AdminFilesFinalizeUploadPost: (
      data: FileFinalizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileAdminDetailWithUser, HTTPValidationError>({
        path: `/api/v1/admin/files/finalize-upload`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate signed GCS upload URLs for a batch of files in a single request. Runs the 4 DB lookups (deployment → location → site → project) exactly ONCE regardless of how many files are in the batch. Previously this was called N times (once per file), causing N×4 redundant DB queries. The frontend should: 1. Call this endpoint once with all file names. 2. Upload each file directly to its signed URL (GCS, no backend involved). 3. Call /files/finalize-uploads once with all gcs_paths.
     *
     * @tags Admin (Files)
     * @name BatchGenerateUploadUrlsApiV1AdminFilesGenerateUploadUrlsPost
     * @summary Batch Generate GCS Upload URLs (Admin/Employee)
     * @request POST:/api/v1/admin/files/generate-upload-urls
     */
    batchGenerateUploadUrlsApiV1AdminFilesGenerateUploadUrlsPost: (
      data: BatchFileUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<BatchFileUploadResponseItem[], HTTPValidationError>({
        path: `/api/v1/admin/files/generate-upload-urls`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finalize a batch of file uploads in a single request. - 1 bulk INSERT for all file records. - Cloud Tasks created concurrently via asyncio.gather (non-blocking).
     *
     * @tags Admin (Files)
     * @name BatchFinalizeUploadsApiV1AdminFilesFinalizeUploadsPost
     * @summary Batch Finalize File Uploads (Admin/Employee)
     * @request POST:/api/v1/admin/files/finalize-uploads
     */
    batchFinalizeUploadsApiV1AdminFilesFinalizeUploadsPost: (
      data: BatchFileFinalizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<BatchFileFinalizeResponse, HTTPValidationError>({
        path: `/api/v1/admin/files/finalize-uploads`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all files for a specific deployment with uploader details. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name GetFilesForDeploymentApiV1AdminFilesDeploymentIdGet
     * @summary List Files for a Deployment (Admin/Employee)
     * @request GET:/api/v1/admin/files/{deployment_id}
     */
    getFilesForDeploymentApiV1AdminFilesDeploymentIdGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<FileAdminDetailWithUser[], HTTPValidationError>({
        path: `/api/v1/admin/files/${deploymentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve files for a deployment that do not have an inference record. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name GetFilesForDeploymentForInferenceApiV1AdminFilesDeploymentIdInferenceGet
     * @summary List Files Needing Inference (Admin/Employee)
     * @request GET:/api/v1/admin/files/{deployment_id}/inference
     */
    getFilesForDeploymentForInferenceApiV1AdminFilesDeploymentIdInferenceGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<FileAdminDetailWithLocation[], HTTPValidationError>({
        path: `/api/v1/admin/files/${deploymentId}/inference`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a signed URL for downloading a file from Google Cloud Storage. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name GetDownloadUrlApiV1AdminFilesFileIdDownloadUrlGet
     * @summary Generate GCS Download URL (Admin/Employee)
     * @request GET:/api/v1/admin/files/{file_id}/download-url
     */
    getDownloadUrlApiV1AdminFilesFileIdDownloadUrlGet: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<FileDownloadResponse, HTTPValidationError>({
        path: `/api/v1/admin/files/${fileId}/download-url`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a signed URL for downloading a spectrogram from Google Cloud Storage. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name GetSpectrogramUrlApiV1AdminFilesFileIdSpectrogramUrlGet
     * @summary Generate GCS Spectrogram Download URL
     * @request GET:/api/v1/admin/files/{file_id}/spectrogram-url
     */
    getSpectrogramUrlApiV1AdminFilesFileIdSpectrogramUrlGet: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<FileDownloadResponse, HTTPValidationError>({
        path: `/api/v1/admin/files/${fileId}/spectrogram-url`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a file record and its object in GCS. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name DeleteApiFileApiV1AdminFilesFileIdDelete
     * @summary Delete a File (Admin/Employee)
     * @request DELETE:/api/v1/admin/files/{file_id}
     */
    deleteApiFileApiV1AdminFilesFileIdDelete: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/admin/files/${fileId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve a list of users with optional filtering, pagination, and sorting. Access Control: - Requires **Admin** role.
     *
     * @tags Admin (Users)
     * @name ListUsersApiV1AdminUsersGet
     * @summary List and Filter Users (Admin Only)
     * @request GET:/api/v1/admin/users
     */
    listUsersApiV1AdminUsersGet: (
      query?: {
        /**
         * Sort By
         * @default "created_at"
         */
        sort_by?: string;
        /**
         * Sort Order
         * @default "desc"
         */
        sort_order?: string;
        /**
         * Page
         * @default 1
         */
        page?: number;
        /**
         * Per Page
         * @default 10
         */
        per_page?: number;
        /** Query */
        query?: string | null;
        /** Role */
        role?: UserRole | null;
        /** Status */
        status?: string | null;
        /** Is Email Verified */
        is_email_verified?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserQueryResult, HTTPValidationError>({
        path: `/api/v1/admin/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve details of a specific user by ID. Access Control: - Requires **Admin** role.
     *
     * @tags Admin (Users)
     * @name GetUserByIdApiV1AdminUsersUserIdGet
     * @summary Get User by ID (Admin Only)
     * @request GET:/api/v1/admin/users/{user_id}
     */
    getUserByIdApiV1AdminUsersUserIdGet: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<AppSchemasUserUserResponse, HTTPValidationError>({
        path: `/api/v1/admin/users/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing user's details, including role and status. Access Control: - Requires **Admin** role.
     *
     * @tags Admin (Users)
     * @name UpdateUserApiV1AdminUsersUserIdPatch
     * @summary Update a User (Admin Only)
     * @request PATCH:/api/v1/admin/users/{user_id}
     */
    updateUserApiV1AdminUsersUserIdPatch: (
      userId: string,
      data: AppSchemasUserUserUpdate,
      params: RequestParams = {},
    ) =>
      this.request<AppSchemasUserUserResponse, HTTPValidationError>({
        path: `/api/v1/admin/users/${userId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a user from the system. **Warning**: Deleting a user will permanently delete: - All projects owned by the user (including sites, locations, deployments, analysis data) - All assignments where the user is assigned - All API keys and permissions associated with the user Access Control: - Requires **Admin** role. Parameters: - **force**: If False (default), deletion will be prevented if user owns projects. If True, deletion will proceed even if user owns projects (with warning logged).
     *
     * @tags Admin (Users)
     * @name DeleteUserApiV1AdminUsersUserIdDelete
     * @summary Delete a User (Admin Only)
     * @request DELETE:/api/v1/admin/users/{user_id}
     */
    deleteUserApiV1AdminUsersUserIdDelete: (
      userId: string,
      query?: {
        /**
         * Force
         * Force deletion even if user owns projects
         * @default false
         */
        force?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AppSchemasUserUserResponse, HTTPValidationError>({
        path: `/api/v1/admin/users/${userId}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a signed URL for uploading a media file for a project.
     *
     * @tags Admin (Project Media)
     * @name GenerateProjectMediaUploadUrlApiV1AdminProjectMediaGenerateUploadUrlPost
     * @summary Generate GCS Upload URL for Project Media
     * @request POST:/api/v1/admin/project-media/generate-upload-url
     */
    generateProjectMediaUploadUrlApiV1AdminProjectMediaGenerateUploadUrlPost: (
      data: ProjectMediaUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMediaUploadResponse, HTTPValidationError>({
        path: `/api/v1/admin/project-media/generate-upload-url`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finalize a project media upload and create its database record.
     *
     * @tags Admin (Project Media)
     * @name FinalizeProjectMediaUploadApiV1AdminProjectMediaFinalizeUploadPost
     * @summary Finalize Project Media Upload
     * @request POST:/api/v1/admin/project-media/finalize-upload
     */
    finalizeProjectMediaUploadApiV1AdminProjectMediaFinalizeUploadPost: (
      data: ProjectMediaFinalizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMedia, HTTPValidationError>({
        path: `/api/v1/admin/project-media/finalize-upload`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all media files for a specific project.
     *
     * @tags Project Media
     * @name GetProjectMediaListApiV1AdminProjectsProjectIdMediaGet
     * @summary List Media for a Project (All Roles)
     * @request GET:/api/v1/admin/projects/{project_id}/media
     */
    getProjectMediaListApiV1AdminProjectsProjectIdMediaGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMedia[], HTTPValidationError>({
        path: `/api/v1/admin/projects/${projectId}/media`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a signed URL for downloading a project media file.
     *
     * @tags Project Media
     * @name GetProjectMediaDownloadUrlApiV1AdminProjectMediaMediaIdDownloadUrlGet
     * @summary Generate GCS Download URL for Project Media (All Roles)
     * @request GET:/api/v1/admin/project-media/{media_id}/download-url
     */
    getProjectMediaDownloadUrlApiV1AdminProjectMediaMediaIdDownloadUrlGet: (
      mediaId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMediaDownloadResponse, HTTPValidationError>({
        path: `/api/v1/admin/project-media/${mediaId}/download-url`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update the caption of a project media file.
     *
     * @tags Admin (Project Media)
     * @name UpdateProjectMediaCaptionApiV1AdminProjectMediaMediaIdPatch
     * @summary Update Project Media Caption
     * @request PATCH:/api/v1/admin/project-media/{media_id}
     */
    updateProjectMediaCaptionApiV1AdminProjectMediaMediaIdPatch: (
      mediaId: string,
      data: ProjectMediaUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMedia, HTTPValidationError>({
        path: `/api/v1/admin/project-media/${mediaId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a project media file record and its object in GCS.
     *
     * @tags Admin (Project Media)
     * @name DeleteProjectMediaApiV1AdminProjectMediaMediaIdDelete
     * @summary Delete Project Media
     * @request DELETE:/api/v1/admin/project-media/{media_id}
     */
    deleteProjectMediaApiV1AdminProjectMediaMediaIdDelete: (
      mediaId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/admin/project-media/${mediaId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Sends a weekly status report for deployments (On Track & Delayed). Automatically disables notifications for projects inactive for > 2 months. Allows authentication via Admin token OR X-Scheduler-Secret header.
     *
     * @tags Admin (Deployments)
     * @name SendWeeklyDeploymentReportApiV1AdminDeploymentsWeeklyReportPost
     * @summary Send Weekly Deployment Status Reports
     * @request POST:/api/v1/admin/deployments/weekly-report
     */
    sendWeeklyDeploymentReportApiV1AdminDeploymentsWeeklyReportPost: (
      query?: {
        /**
         * Project Id
         * Optional project ID to send report for.
         */
        project_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/admin/deployments/weekly-report`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Save tree DBH/Age/Height data for carbon sequestration.
     *
     * @tags Admin (Deployments)
     * @name CreateOrUpdateCarbonSequestrationApiApiV1AdminDeploymentsDeploymentIdCarbonSequestrationPost
     * @summary Create or Update Carbon Sequestration Data
     * @request POST:/api/v1/admin/deployments/{deployment_id}/carbon-sequestration
     */
    createOrUpdateCarbonSequestrationApiApiV1AdminDeploymentsDeploymentIdCarbonSequestrationPost:
      (
        deploymentId: string,
        data: CarbonSequestrationCreate,
        params: RequestParams = {},
      ) =>
        this.request<CarbonSequestrationResponse, HTTPValidationError>({
          path: `/api/v1/admin/deployments/${deploymentId}/carbon-sequestration`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Run batch inference for all pending/failed files when triggered via a specific file.
     *
     * @tags Inference
     * @name RunInferenceOnFileApiV1AdminInferenceFileFileIdPost
     * @summary Run Inference On File
     * @request POST:/api/v1/admin/inference/file/{file_id}
     */
    runInferenceOnFileApiV1AdminInferenceFileFileIdPost: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/admin/inference/file/${fileId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a single inference record by ID.
     *
     * @tags Inference
     * @name GetApiInferenceApiV1AdminInferenceInferenceIdGet
     * @summary Get Api Inference
     * @request GET:/api/v1/admin/inference/{inference_id}
     */
    getApiInferenceApiV1AdminInferenceInferenceIdGet: (
      inferenceId: string,
      params: RequestParams = {},
    ) =>
      this.request<Inference, HTTPValidationError>({
        path: `/api/v1/admin/inference/${inferenceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing inference record.
     *
     * @tags Inference
     * @name UpdateApiInferenceApiV1AdminInferenceInferenceIdPut
     * @summary Update Api Inference
     * @request PUT:/api/v1/admin/inference/{inference_id}
     */
    updateApiInferenceApiV1AdminInferenceInferenceIdPut: (
      inferenceId: string,
      data: InferenceUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Inference, HTTPValidationError>({
        path: `/api/v1/admin/inference/${inferenceId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an inference record.
     *
     * @tags Inference
     * @name DeleteApiInferenceApiV1AdminInferenceInferenceIdDelete
     * @summary Delete Api Inference
     * @request DELETE:/api/v1/admin/inference/{inference_id}
     */
    deleteApiInferenceApiV1AdminInferenceInferenceIdDelete: (
      inferenceId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/admin/inference/${inferenceId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve all inference records for a given file ID.
     *
     * @tags Inference
     * @name GetApiInferencesByFileIdApiV1AdminInferenceByFileFileIdGet
     * @summary Get Api Inferences By File Id
     * @request GET:/api/v1/admin/inference/by_file/{file_id}
     */
    getApiInferencesByFileIdApiV1AdminInferenceByFileFileIdGet: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<Inference[], HTTPValidationError>({
        path: `/api/v1/admin/inference/by_file/${fileId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Callback endpoint for Vertex AI / BirdNET to push inference results when a file is processed.
     *
     * @tags Inference
     * @name InferenceCallbackApiV1AdminInferenceCallbackFileIdPost
     * @summary Inference Callback
     * @request POST:/api/v1/admin/inference/callback/{file_id}
     */
    inferenceCallbackApiV1AdminInferenceCallbackFileIdPost: (
      fileId: string,
      data: Record<string, any>,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/admin/inference/callback/${fileId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Create a new assignment**, linking a user (Employee, FieldWorker, or DEV) to a project. - Requires **Admin** or **Employee** role. Employees can only assign FieldWorkers to projects they manage. - Business Rules: - Maximum 1 DEV user per project (must be from same organization as project owner) - Maximum 1 Employee user per project (can be from any organization) - Employee users can be assigned to multiple different projects - DEV users must be from the same organization as the project owner
     *
     * @tags Assignments
     * @name CreateAssignmentEndpointApiV1AssignmentsPost
     * @summary Create Assignment Endpoint
     * @request POST:/api/v1/assignments/
     */
    createAssignmentEndpointApiV1AssignmentsPost: (
      data: AssignmentCreate,
      params: RequestParams = {},
    ) =>
      this.request<Assignment, HTTPValidationError>({
        path: `/api/v1/assignments/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve all assignments in the system.** - Requires **Admin** role. - Returns a list of assignment objects with nested user and project details. - Supports pagination with `skip` and `limit` parameters.
     *
     * @tags Assignments
     * @name ListAllAssignmentsApiV1AssignmentsGet
     * @summary List All Assignments
     * @request GET:/api/v1/assignments/
     */
    listAllAssignmentsApiV1AssignmentsGet: (
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Assignment[], HTTPValidationError>({
        path: `/api/v1/assignments/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description **Create multiple assignments** linking a DEV user to multiple projects. - Requires **Admin** role. - Business Rules (same as single assignment): - Maximum 1 DEV user per project - User must be from same organization as project owner - Returns a list of created assignment objects with nested user and project details. - Returns an empty list if no assignments are created.
     *
     * @tags Assignments
     * @name CreateBulkAssignmentsApiV1AssignmentsBulkPost
     * @summary Create Bulk Assignments
     * @request POST:/api/v1/assignments/bulk
     */
    createBulkAssignmentsApiV1AssignmentsBulkPost: (
      query: {
        /**
         * User Id
         * @format uuid
         */
        user_id: string;
      },
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<Assignment[], HTTPValidationError>({
        path: `/api/v1/assignments/bulk`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve all projects by organization email.** - Requires **Admin** role - Returns a list of project objects for all users in the organization (based on email domain). - Supports pagination with `skip` and `limit` parameters. - The org_email can be any email from the organization (e.g., "user@example.com"). - It will find all users with the same domain (e.g., "@example.com") and return their projects.
     *
     * @tags Assignments
     * @name GetProjectsByOrgEmailApiV1AssignmentsProjectsByOrgEmailOrgEmailGet
     * @summary Get Projects By Org Email
     * @request GET:/api/v1/assignments/projects-by-org-email/{org_email}
     */
    getProjectsByOrgEmailApiV1AssignmentsProjectsByOrgEmailOrgEmailGet: (
      orgEmail: string,
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Project[], HTTPValidationError>({
        path: `/api/v1/assignments/projects-by-org-email/${orgEmail}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve all assignments for a specific project.** - Requires **Admin** role. - Returns a list of assignment objects with nested user and project details. - A project can have maximum 1 DEV user (from same org as owner) and 1 Employee user. - Returns an empty list if no assignments are found for the given project ID.
     *
     * @tags Assignments
     * @name GetAssignmentsByProjectApiV1AssignmentsProjectProjectIdGet
     * @summary Get Assignments By Project
     * @request GET:/api/v1/assignments/project/{project_id}
     */
    getAssignmentsByProjectApiV1AssignmentsProjectProjectIdGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<Assignment[], HTTPValidationError>({
        path: `/api/v1/assignments/project/${projectId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve all assignments for a specific user (employee/fieldworker).** - Requires **Admin** or **Employee** role. - Returns a list of assignment objects with nested user and project details. - Returns an empty list if the user has no assignments.
     *
     * @tags Assignments
     * @name GetAssignmentsByUserApiV1AssignmentsUserUserIdGet
     * @summary Get Assignments By User
     * @request GET:/api/v1/assignments/user/{user_id}
     */
    getAssignmentsByUserApiV1AssignmentsUserUserIdGet: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<Assignment[], HTTPValidationError>({
        path: `/api/v1/assignments/user/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve a single assignment by its unique ID.** - Requires **Admin** role. - Returns the assignment object with nested user and project details. - Raises 404 if the assignment is not found.
     *
     * @tags Assignments
     * @name GetAssignmentByIdApiV1AssignmentsAssignmentIdGet
     * @summary Get Assignment By Id
     * @request GET:/api/v1/assignments/{assignment_id}
     */
    getAssignmentByIdApiV1AssignmentsAssignmentIdGet: (
      assignmentId: string,
      params: RequestParams = {},
    ) =>
      this.request<Assignment, HTTPValidationError>({
        path: `/api/v1/assignments/${assignmentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Delete an assignment** by its unique ID. - Requires **Admin** or **Employee** role. - Returns 204 No Content on successful deletion. - Raises 404 if the assignment is not found.
     *
     * @tags Assignments
     * @name DeleteAssignmentEndpointApiV1AssignmentsAssignmentIdDelete
     * @summary Delete Assignment Endpoint
     * @request DELETE:/api/v1/assignments/{assignment_id}
     */
    deleteAssignmentEndpointApiV1AssignmentsAssignmentIdDelete: (
      assignmentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/assignments/${assignmentId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve files with their inference data.
     *
     * @tags Inferences
     * @name ReadFilesWithInferencesApiV1InferencesFilesGet
     * @summary Read Files With Inferences
     * @request GET:/api/v1/inferences/files
     */
    readFilesWithInferencesApiV1InferencesFilesGet: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 200
         * @default 100
         */
        limit?: number;
        /** Device Type */
        device_type?: DeviceType | null;
        /**
         * Sort By
         * @default "created_at"
         */
        sort_by?: string;
        /**
         * Sort Order
         * @default "desc"
         * @pattern ^(asc|desc)$
         */
        sort_order?: string;
        /**
         * Entityid
         * Filter by entity, e.g., "enr:site:..."
         */
        entityId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<FileDetailList, HTTPValidationError>({
        path: `/api/v1/inferences/files`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Batch Inference
     * @name SubmitBatchJobApiV1BatchJobsPost
     * @summary Submit Batch Job
     * @request POST:/api/v1/batch/jobs
     */
    submitBatchJobApiV1BatchJobsPost: (
      data: SubmitBatchRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/api/v1/batch/jobs`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description One poll step. Driven by Cloud Tasks (OIDC-verified) in staging/prod.
     *
     * @tags Batch Inference
     * @name PollBatchJobApiV1BatchJobsJobIdPollPost
     * @summary Poll Batch Job
     * @request POST:/api/v1/batch/jobs/{job_id}/poll
     */
    pollBatchJobApiV1BatchJobsJobIdPollPost: (
      jobId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/api/v1/batch/jobs/${jobId}/poll`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Batch Inference
     * @name GetBatchJobApiV1BatchJobsJobIdGet
     * @summary Get Batch Job
     * @request GET:/api/v1/batch/jobs/{job_id}
     */
    getBatchJobApiV1BatchJobsJobIdGet: (
      jobId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/api/v1/batch/jobs/${jobId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new support ticket.
     *
     * @tags Support
     * @name CreateSupportTicketApiV1SupportTicketsPost
     * @summary Create Support Ticket
     * @request POST:/api/v1/support/tickets
     */
    createSupportTicketApiV1SupportTicketsPost: (
      data: SupportTicketCreate,
      params: RequestParams = {},
    ) =>
      this.request<SupportTicket, HTTPValidationError>({
        path: `/api/v1/support/tickets`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get support tickets for the current user. Admins can see all tickets.
     *
     * @tags Support
     * @name GetSupportTicketsApiV1SupportTicketsGet
     * @summary Get Support Tickets
     * @request GET:/api/v1/support/tickets
     */
    getSupportTicketsApiV1SupportTicketsGet: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 100
         * @default 100
         */
        limit?: number;
        /** Status */
        status?: string | null;
        /** Category */
        category?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SupportTicketList, HTTPValidationError>({
        path: `/api/v1/support/tickets`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a specific support ticket by ID.
     *
     * @tags Support
     * @name GetSupportTicketApiV1SupportTicketsTicketIdGet
     * @summary Get Support Ticket
     * @request GET:/api/v1/support/tickets/{ticket_id}
     */
    getSupportTicketApiV1SupportTicketsTicketIdGet: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<SupportTicket, HTTPValidationError>({
        path: `/api/v1/support/tickets/${ticketId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a support ticket (admin only).
     *
     * @tags Support
     * @name UpdateSupportTicketApiV1SupportTicketsTicketIdPatch
     * @summary Update Support Ticket
     * @request PATCH:/api/v1/support/tickets/{ticket_id}
     */
    updateSupportTicketApiV1SupportTicketsTicketIdPatch: (
      ticketId: string,
      data: SupportTicketUpdate,
      params: RequestParams = {},
    ) =>
      this.request<SupportTicket, HTTPValidationError>({
        path: `/api/v1/support/tickets/${ticketId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Worker endpoint called by Cloud Tasks to process audio files. Status flow: PENDING → RUNNING → COMPLETED | FAILED
     *
     * @tags Worker
     * @name ProcessAudioApiV1WorkerProcessPost
     * @summary Process Audio
     * @request POST:/api/v1/worker/process
     */
    processAudioApiV1WorkerProcessPost: (
      data: AudioProcessingRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/worker/process`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Register or update a user's device push token.
     *
     * @tags Notifications
     * @name RegisterDeviceApiV1NotificationsDevicesPost
     * @summary Register Device
     * @request POST:/api/v1/notifications/devices
     */
    registerDeviceApiV1NotificationsDevicesPost: (
      data: UserDeviceCreate,
      params: RequestParams = {},
    ) =>
      this.request<UserDevice, HTTPValidationError>({
        path: `/api/v1/notifications/devices`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a device push token (e.g., on logout).
     *
     * @tags Notifications
     * @name UnregisterDeviceApiV1NotificationsDevicesDelete
     * @summary Unregister Device
     * @request DELETE:/api/v1/notifications/devices
     */
    unregisterDeviceApiV1NotificationsDevicesDelete: (
      query: {
        /** Expo Push Token */
        expo_push_token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/notifications/devices`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Periodic task to check for upcoming deployments (24h before start/end). Sends push notifications to assigned field workers using Expo. This endpoint is designed for automation via Cloud Scheduler (every 5 min). Access is restricted by a shared secret set in the environment.
     *
     * @tags Notifications
     * @name CheckDeploymentsForNotificationsApiV1NotificationsCheckDeploymentsPost
     * @summary Check Deployments For Notifications
     * @request POST:/api/v1/notifications/check-deployments
     */
    checkDeploymentsForNotificationsApiV1NotificationsCheckDeploymentsPost: (
      params: RequestParams = {},
    ) =>
      this.request<NotificationCheckResult, HTTPValidationError>({
        path: `/api/v1/notifications/check-deployments`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name CreateDeveloperApiV1DevelopersPost
     * @summary Create Developer
     * @request POST:/api/v1/developers
     */
    createDeveloperApiV1DevelopersPost: (
      data: UserCreate,
      params: RequestParams = {},
    ) =>
      this.request<UserCreateResponse, HTTPValidationError>({
        path: `/api/v1/developers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name ListDevelopersUsersApiV1DevelopersGet
     * @summary List Developers Users
     * @request GET:/api/v1/developers
     */
    listDevelopersUsersApiV1DevelopersGet: (
      query?: {
        /**
         * Sort By
         * @default "created_at"
         */
        sort_by?: string;
        /**
         * Sort Order
         * @default "desc"
         */
        sort_order?: string;
        /**
         * Page
         * @default 1
         */
        page?: number;
        /**
         * Per Page
         * @default 10
         */
        per_page?: number;
        /** Query */
        query?: string | null;
        /** Role */
        role?: UserRole | null;
        /** Status */
        status?: string | null;
        /** Is Email Verified */
        is_email_verified?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserQueryResult, HTTPValidationError>({
        path: `/api/v1/developers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get current developer profile. Requires X-API-Key or Authorization: Bearer <api_key>
     *
     * @tags Developers, Developers
     * @name ReadDeveloperMeApiV1DevelopersMeGet
     * @summary Read Developer Me
     * @request GET:/api/v1/developers/me
     */
    readDeveloperMeApiV1DevelopersMeGet: (params: RequestParams = {}) =>
      this.request<UserOut, any>({
        path: `/api/v1/developers/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name GetDeveloperApiV1DevelopersUserIdGet
     * @summary Get Developer
     * @request GET:/api/v1/developers/{user_id}
     */
    getDeveloperApiV1DevelopersUserIdGet: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<UserOut, HTTPValidationError>({
        path: `/api/v1/developers/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name UpdateDeveloperUserApiV1DevelopersUserIdPut
     * @summary Update Developer User
     * @request PUT:/api/v1/developers/{user_id}
     */
    updateDeveloperUserApiV1DevelopersUserIdPut: (
      userId: string,
      data: AppSchemasUserUserUpdate,
      params: RequestParams = {},
    ) =>
      this.request<AppSchemasUserUserResponse, HTTPValidationError>({
        path: `/api/v1/developers/${userId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name DeleteDeveloperUserApiV1DevelopersUserIdDelete
     * @summary Delete Developer User
     * @request DELETE:/api/v1/developers/{user_id}
     */
    deleteDeveloperUserApiV1DevelopersUserIdDelete: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<AppSchemasUserUserResponse, HTTPValidationError>({
        path: `/api/v1/developers/${userId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name UpdateDeveloperStatusApiV1DevelopersUserIdStatusPatch
     * @summary Update Developer Status
     * @request PATCH:/api/v1/developers/{user_id}/status
     */
    updateDeveloperStatusApiV1DevelopersUserIdStatusPatch: (
      userId: string,
      data: UserStatusUpdate,
      params: RequestParams = {},
    ) =>
      this.request<AppSchemasUserUserResponse, HTTPValidationError>({
        path: `/api/v1/developers/${userId}/status`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new API endpoint (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name CreateApiEndpointApiV1ApiEndpointsPost
     * @summary Create Api Endpoint
     * @request POST:/api/v1/api-endpoints/
     */
    createApiEndpointApiV1ApiEndpointsPost: (
      data: APIEndpointCreate,
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointOut, HTTPValidationError>({
        path: `/api/v1/api-endpoints/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List API endpoints with filtering and pagination (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name ListApiEndpointsApiV1ApiEndpointsGet
     * @summary List Api Endpoints
     * @request GET:/api/v1/api-endpoints/
     */
    listApiEndpointsApiV1ApiEndpointsGet: (
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Per Page
         * @min 1
         * @max 100
         * @default 10
         */
        per_page?: number;
        /** Query */
        query?: string | null;
        /** Enabled */
        enabled?: boolean | null;
        /** Service Name */
        service_name?: string | null;
        /**
         * Sort By
         * @default "created_at"
         */
        sort_by?: string | null;
        /**
         * Sort Order
         * @default "desc"
         */
        sort_order?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointQueryResult, HTTPValidationError>({
        path: `/api/v1/api-endpoints/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get API endpoint by ID (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name GetApiEndpointApiV1ApiEndpointsEndpointIdGet
     * @summary Get Api Endpoint
     * @request GET:/api/v1/api-endpoints/{endpoint_id}
     */
    getApiEndpointApiV1ApiEndpointsEndpointIdGet: (
      endpointId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointOut, HTTPValidationError>({
        path: `/api/v1/api-endpoints/${endpointId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update API endpoint (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name UpdateApiEndpointApiV1ApiEndpointsEndpointIdPut
     * @summary Update Api Endpoint
     * @request PUT:/api/v1/api-endpoints/{endpoint_id}
     */
    updateApiEndpointApiV1ApiEndpointsEndpointIdPut: (
      endpointId: string,
      data: APIEndpointUpdate,
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointOut, HTTPValidationError>({
        path: `/api/v1/api-endpoints/${endpointId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete API endpoint (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name DeleteApiEndpointApiV1ApiEndpointsEndpointIdDelete
     * @summary Delete Api Endpoint
     * @request DELETE:/api/v1/api-endpoints/{endpoint_id}
     */
    deleteApiEndpointApiV1ApiEndpointsEndpointIdDelete: (
      endpointId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointOut, HTTPValidationError>({
        path: `/api/v1/api-endpoints/${endpointId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Enable or disable an API endpoint (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name ToggleApiEndpointApiV1ApiEndpointsEndpointIdTogglePatch
     * @summary Toggle Api Endpoint
     * @request PATCH:/api/v1/api-endpoints/{endpoint_id}/toggle
     */
    toggleApiEndpointApiV1ApiEndpointsEndpointIdTogglePatch: (
      endpointId: string,
      data: APIEndpointToggle,
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointOut, HTTPValidationError>({
        path: `/api/v1/api-endpoints/${endpointId}/toggle`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys, API Keys
     * @name CreateApiKeyApiV1ApiKeysCreatePost
     * @summary Create Api Key
     * @request POST:/api/v1/api-keys/create
     */
    createApiKeyApiV1ApiKeysCreatePost: (
      query: {
        /**
         * User Id
         * @format uuid
         */
        user_id: string;
        /** Environment */
        environment: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<APIKeyCreateResponse, HTTPValidationError>({
        path: `/api/v1/api-keys/create`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys
     * @name GetApiKeyApiV1ApiKeysApiKeyIdGet
     * @summary Get Api Key
     * @request GET:/api/v1/api-keys/{api_key_id}
     */
    getApiKeyApiV1ApiKeysApiKeyIdGet: (
      apiKeyId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIKeyOut, HTTPValidationError>({
        path: `/api/v1/api-keys/${apiKeyId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description List all API keys with pagination and filtering. - Supports pagination via `page` and `per_page` parameters - Can filter by `status` (active, revoked, expired) - Can filter by `user_id` to get keys for a specific user - Supports sorting via `sort_by` and `sort_order` parameters
     *
     * @tags API Keys, API Keys
     * @name ListApiKeysApiV1ApiKeysGet
     * @summary List Api Keys
     * @request GET:/api/v1/api-keys/
     */
    listApiKeysApiV1ApiKeysGet: (
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Per Page
         * @min 1
         * @max 100
         * @default 10
         */
        per_page?: number;
        /** Status */
        status?: string | null;
        /** User Id */
        user_id?: string | null;
        /**
         * Sort By
         * @default "created_at"
         */
        sort_by?: string | null;
        /**
         * Sort Order
         * @default "desc"
         */
        sort_order?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<APIKeyQueryResult, HTTPValidationError>({
        path: `/api/v1/api-keys/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys, API Keys
     * @name RevokeApiKeyApiV1ApiKeysApiKeyIdRevokePut
     * @summary Revoke Api Key
     * @request PUT:/api/v1/api-keys/{api_key_id}/revoke
     */
    revokeApiKeyApiV1ApiKeysApiKeyIdRevokePut: (
      apiKeyId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIKeyRevokeResponse, HTTPValidationError>({
        path: `/api/v1/api-keys/${apiKeyId}/revoke`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys, API Keys
     * @name RegenerateApiKeyApiV1ApiKeysApiKeyIdRegeneratePost
     * @summary Regenerate Api Key
     * @request POST:/api/v1/api-keys/{api_key_id}/regenerate
     */
    regenerateApiKeyApiV1ApiKeysApiKeyIdRegeneratePost: (
      apiKeyId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIKeyRegenerateResponse, HTTPValidationError>({
        path: `/api/v1/api-keys/${apiKeyId}/regenerate`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys, API Keys
     * @name GetApiKeyUsageApiV1ApiKeysApiKeyIdUsageGet
     * @summary Get Api Key Usage
     * @request GET:/api/v1/api-keys/{api_key_id}/usage
     */
    getApiKeyUsageApiV1ApiKeysApiKeyIdUsageGet: (
      apiKeyId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIKeyUsageResponse, HTTPValidationError>({
        path: `/api/v1/api-keys/${apiKeyId}/usage`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys, API Keys
     * @name GetApiKeyPermissionsApiV1ApiKeysApiKeyIdPermissionsGet
     * @summary Get Api Key Permissions
     * @request GET:/api/v1/api-keys/{api_key_id}/permissions
     */
    getApiKeyPermissionsApiV1ApiKeysApiKeyIdPermissionsGet: (
      apiKeyId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIKeyPermissionsResponse, HTTPValidationError>({
        path: `/api/v1/api-keys/${apiKeyId}/permissions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Assign an API endpoint to a developer (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name AssignEndpointToDeveloperApiV1DevelopersDeveloperIdPermissionsPost
     * @summary Assign Endpoint To Developer
     * @request POST:/api/v1/developers/{developer_id}/permissions
     */
    assignEndpointToDeveloperApiV1DevelopersDeveloperIdPermissionsPost: (
      developerId: string,
      data: DeveloperPermissionCreate,
      params: RequestParams = {},
    ) =>
      this.request<DeveloperPermissionOut, HTTPValidationError>({
        path: `/api/v1/developers/${developerId}/permissions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all permissions (assigned endpoints) for a developer (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name ListDeveloperPermissionsApiV1DevelopersDeveloperIdPermissionsGet
     * @summary List Developer Permissions
     * @request GET:/api/v1/developers/{developer_id}/permissions
     */
    listDeveloperPermissionsApiV1DevelopersDeveloperIdPermissionsGet: (
      developerId: string,
      query?: {
        /**
         * Status Filter
         * Filter by status: 'active' or 'inactive'
         */
        status_filter?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeveloperPermissionListResponse, HTTPValidationError>({
        path: `/api/v1/developers/${developerId}/permissions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Bulk assign multiple endpoints to a developer (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name BulkAssignEndpointsToDeveloperApiV1DevelopersDeveloperIdPermissionsBulkPost
     * @summary Bulk Assign Endpoints To Developer
     * @request POST:/api/v1/developers/{developer_id}/permissions/bulk
     */
    bulkAssignEndpointsToDeveloperApiV1DevelopersDeveloperIdPermissionsBulkPost:
      (
        developerId: string,
        data: DeveloperPermissionBulkCreate,
        params: RequestParams = {},
      ) =>
        this.request<DeveloperPermissionOut[], HTTPValidationError>({
          path: `/api/v1/developers/${developerId}/permissions/bulk`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Get permission by ID (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name GetPermissionApiV1PermissionsPermissionIdGet
     * @summary Get Permission
     * @request GET:/api/v1/permissions/{permission_id}
     */
    getPermissionApiV1PermissionsPermissionIdGet: (
      permissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeveloperPermissionOut, HTTPValidationError>({
        path: `/api/v1/permissions/${permissionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Revoke endpoint access from developer (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name RevokePermissionApiV1PermissionsPermissionIdDelete
     * @summary Revoke Permission
     * @request DELETE:/api/v1/permissions/{permission_id}
     */
    revokePermissionApiV1PermissionsPermissionIdDelete: (
      permissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeveloperPermissionOut, HTTPValidationError>({
        path: `/api/v1/permissions/${permissionId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Activate or deactivate a permission (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name TogglePermissionStatusApiV1PermissionsPermissionIdStatusPatch
     * @summary Toggle Permission Status
     * @request PATCH:/api/v1/permissions/{permission_id}/status
     */
    togglePermissionStatusApiV1PermissionsPermissionIdStatusPatch: (
      permissionId: string,
      data: DeveloperPermissionToggle,
      params: RequestParams = {},
    ) =>
      this.request<DeveloperPermissionOut, HTTPValidationError>({
        path: `/api/v1/permissions/${permissionId}/status`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Revoke specific endpoint access from developer (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name RevokeEndpointFromDeveloperApiV1DevelopersDeveloperIdPermissionsEndpointIdDelete
     * @summary Revoke Endpoint From Developer
     * @request DELETE:/api/v1/developers/{developer_id}/permissions/{endpoint_id}
     */
    revokeEndpointFromDeveloperApiV1DevelopersDeveloperIdPermissionsEndpointIdDelete:
      (developerId: string, endpointId: string, params: RequestParams = {}) =>
        this.request<DeveloperPermissionOut, HTTPValidationError>({
          path: `/api/v1/developers/${developerId}/permissions/${endpointId}`,
          method: "DELETE",
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags Admin Logs, Logs
     * @name GetApiRequestLogsApiV1AdminLogsRequestsGet
     * @summary Get Api Request Logs
     * @request GET:/api/v1/admin/logs/requests
     */
    getApiRequestLogsApiV1AdminLogsRequestsGet: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 100
         * @default 100
         */
        limit?: number;
        /** Developer Id */
        developer_id?: string | null;
        /** Endpoint Path */
        endpoint_path?: string | null;
        /** Status Code */
        status_code?: number | null;
        /** Start Date */
        start_date?: string | null;
        /** End Date */
        end_date?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<APIRequestLogOut[], HTTPValidationError>({
        path: `/api/v1/admin/logs/requests`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Logs, Logs
     * @name GetApiRequestLogApiV1AdminLogsRequestRequestIdGet
     * @summary Get Api Request Log
     * @request GET:/api/v1/admin/logs/request/{request_id}
     */
    getApiRequestLogApiV1AdminLogsRequestRequestIdGet: (
      requestId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIRequestLogOut, HTTPValidationError>({
        path: `/api/v1/admin/logs/request/${requestId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Logs, Logs
     * @name DeleteApiRequestLogApiV1AdminLogsRequestRequestIdDelete
     * @summary Delete Api Request Log
     * @request DELETE:/api/v1/admin/logs/request/{request_id}
     */
    deleteApiRequestLogApiV1AdminLogsRequestRequestIdDelete: (
      requestId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/api/v1/admin/logs/request/${requestId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Logs, Logs
     * @name GetAuditLogsApiV1AdminLogsAuditLogsGet
     * @summary Get Audit Logs
     * @request GET:/api/v1/admin/logs/audit-logs
     */
    getAuditLogsApiV1AdminLogsAuditLogsGet: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 100
         * @default 100
         */
        limit?: number;
        /** Admin User Id */
        admin_user_id?: string | null;
        /** Action */
        action?: string | null;
        /** Entity Type */
        entity_type?: string | null;
        /** Entity Id */
        entity_id?: string | null;
        /** Start Date */
        start_date?: string | null;
        /** End Date */
        end_date?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuditLogOut[], HTTPValidationError>({
        path: `/api/v1/admin/logs/audit-logs`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fieldworkers
     * @name RegisterFieldworkerApiV1FieldworkersRegisterFieldworkersPost
     * @summary Register a new FieldWorker (Admin/Employee)
     * @request POST:/api/v1/fieldworkers/register/fieldworkers
     */
    registerFieldworkerApiV1FieldworkersRegisterFieldworkersPost: (
      data: UserCreate,
      params: RequestParams = {},
    ) =>
      this.request<AppSchemasUserUserResponse, HTTPValidationError>({
        path: `/api/v1/fieldworkers/register/fieldworkers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fieldworkers
     * @name ListManagerFieldworkersApiV1FieldworkersManagerFieldworkersGet
     * @summary List Fieldworkers for a Manager (Employee)
     * @request GET:/api/v1/fieldworkers/manager/fieldworkers
     */
    listManagerFieldworkersApiV1FieldworkersManagerFieldworkersGet: (
      params: RequestParams = {},
    ) =>
      this.request<UserQueryResult, any>({
        path: `/api/v1/fieldworkers/manager/fieldworkers`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fieldworkers
     * @name UpdateFieldworkerApiV1FieldworkersManagerFieldworkersUserIdPatch
     * @summary Update Fieldworker Profile (Admin/Employee)
     * @request PATCH:/api/v1/fieldworkers/manager/fieldworkers/{user_id}
     */
    updateFieldworkerApiV1FieldworkersManagerFieldworkersUserIdPatch: (
      userId: string,
      data: AppSchemasUserUserUpdate,
      params: RequestParams = {},
    ) =>
      this.request<AppSchemasUserUserResponse, HTTPValidationError>({
        path: `/api/v1/fieldworkers/manager/fieldworkers/${userId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new species record and optionally upload an image in a single request. Requires multipart/form-data.
     *
     * @tags Species
     * @name CreateSpeciesApiV1SpeciesPost
     * @summary Create a new species with an optional image
     * @request POST:/api/v1/species
     */
    createSpeciesApiV1SpeciesPost: (
      data: BodyCreateSpeciesApiV1SpeciesPost,
      params: RequestParams = {},
    ) =>
      this.request<Species, HTTPValidationError>({
        path: `/api/v1/species`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all species.
     *
     * @tags Species
     * @name ReadSpeciesApiV1SpeciesGet
     * @summary List species
     * @request GET:/api/v1/species
     */
    readSpeciesApiV1SpeciesGet: (
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Species[], HTTPValidationError>({
        path: `/api/v1/species`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a secure signed HTTPS URL to display the species image on the frontend.
     *
     * @tags Species
     * @name GetSpeciesViewableImageApiV1SpeciesSpeciesIdViewImageGet
     * @summary Get a viewable signed URL for the species image
     * @request GET:/api/v1/species/{species_id}/view-image
     */
    getSpeciesViewableImageApiV1SpeciesSpeciesIdViewImageGet: (
      speciesId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/species/${speciesId}/view-image`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a species record from the database. Also deletes all associated images for this species from Google Cloud Storage.
     *
     * @tags Species
     * @name DeleteSpeciesApiV1SpeciesSpeciesIdDelete
     * @summary Delete a species and its images
     * @request DELETE:/api/v1/species/{species_id}
     */
    deleteSpeciesApiV1SpeciesSpeciesIdDelete: (
      speciesId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/species/${speciesId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Client Data Room, Client Data Room
     * @name GetTreeApiV1ProjectsProjectIdDataRoomTreeGet
     * @summary Get the merged file-browser tree (deployment + custom branches)
     * @request GET:/api/v1/projects/{project_id}/data-room/tree
     */
    getTreeApiV1ProjectsProjectIdDataRoomTreeGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<ClientTreeResponse, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/data-room/tree`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Lists the real files under a deployment's audios/images folder by reading the dedicated bucket. Read-only; returns names + sizes.
     *
     * @tags Client Data Room, Client Data Room
     * @name ListDeploymentFilesApiV1ProjectsProjectIdDataRoomDeploymentFilesGet
     * @summary List actual files inside a deployment audios/images folder (read-only)
     * @request GET:/api/v1/projects/{project_id}/data-room/deployment-files
     */
    listDeploymentFilesApiV1ProjectsProjectIdDataRoomDeploymentFilesGet: (
      projectId: string,
      query: {
        /**
         * Deployment Id
         * @format uuid
         */
        deployment_id: string;
        /**
         * Folder
         * @pattern ^(audios|images)$
         */
        folder: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/data-room/deployment-files`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Client Data Room, Client Data Room
     * @name CreateFolderApiV1ProjectsProjectIdDataRoomFoldersPost
     * @summary Create a folder in the writable branch
     * @request POST:/api/v1/projects/{project_id}/data-room/folders
     */
    createFolderApiV1ProjectsProjectIdDataRoomFoldersPost: (
      projectId: string,
      data: CreateFolderRequest,
      params: RequestParams = {},
    ) =>
      this.request<ClientNode, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/data-room/folders`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Client Data Room, Client Data Room
     * @name InitiateUploadApiV1ProjectsProjectIdDataRoomUploadsInitiatePost
     * @summary Start a resumable upload session for a file
     * @request POST:/api/v1/projects/{project_id}/data-room/uploads/initiate
     */
    initiateUploadApiV1ProjectsProjectIdDataRoomUploadsInitiatePost: (
      projectId: string,
      data: InitiateUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<InitiateUploadResponse, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/data-room/uploads/initiate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Client Data Room, Client Data Room
     * @name FinalizeUploadApiV1ProjectsProjectIdDataRoomUploadsFinalizePost
     * @summary Record the file row after the browser finishes uploading
     * @request POST:/api/v1/projects/{project_id}/data-room/uploads/finalize
     */
    finalizeUploadApiV1ProjectsProjectIdDataRoomUploadsFinalizePost: (
      projectId: string,
      data: FinalizeUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<ClientNode, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/data-room/uploads/finalize`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Client Data Room, Client Data Room
     * @name GetDownloadUrlApiV1ProjectsProjectIdDataRoomDownloadUrlGet
     * @summary Get a signed GET URL to view/play/download a file
     * @request GET:/api/v1/projects/{project_id}/data-room/download-url
     */
    getDownloadUrlApiV1ProjectsProjectIdDataRoomDownloadUrlGet: (
      projectId: string,
      query: {
        /** Gcs Path */
        gcs_path: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DownloadUrlResponse, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/data-room/download-url`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Client Data Room, Client Data Room
     * @name DeleteNodeApiV1ProjectsProjectIdDataRoomNodesNodeIdDelete
     * @summary Delete a folder (and its subtree) or a file from the writable branch
     * @request DELETE:/api/v1/projects/{project_id}/data-room/nodes/{node_id}
     */
    deleteNodeApiV1ProjectsProjectIdDataRoomNodesNodeIdDelete: (
      nodeId: string,
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/projects/${projectId}/data-room/nodes/${nodeId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name ListSoilElementsApiV1SoilChemistryElementsGet
     * @summary List soil element catalog items
     * @request GET:/api/v1/soil-chemistry/elements
     */
    listSoilElementsApiV1SoilChemistryElementsGet: (
      query?: {
        /**
         * Category
         * Filter by category (e.g. Nutrients, Chemical)
         */
        category?: string | null;
        /**
         * Search
         * Search by element name or symbol
         */
        search?: string | null;
        /**
         * Is Active
         * Filter by active status (None for all, True for active only, False for inactive)
         */
        is_active?: boolean | null;
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 500
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SoilElementResponse[], HTTPValidationError>({
        path: `/api/v1/soil-chemistry/elements`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name CreateSoilElementApiV1SoilChemistryElementsPost
     * @summary Create a custom soil element catalog item
     * @request POST:/api/v1/soil-chemistry/elements
     */
    createSoilElementApiV1SoilChemistryElementsPost: (
      data: SoilElementCreate,
      params: RequestParams = {},
    ) =>
      this.request<SoilElementResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/elements`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name SeedSoilElementsApiV1SoilChemistryElementsSeedPost
     * @summary Seed default standard soil elements catalog
     * @request POST:/api/v1/soil-chemistry/elements/seed
     */
    seedSoilElementsApiV1SoilChemistryElementsSeedPost: (
      params: RequestParams = {},
    ) =>
      this.request<SoilElementResponse[], any>({
        path: `/api/v1/soil-chemistry/elements/seed`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name GetSoilElementApiV1SoilChemistryElementsElementIdGet
     * @summary Get soil element details by ID
     * @request GET:/api/v1/soil-chemistry/elements/{element_id}
     */
    getSoilElementApiV1SoilChemistryElementsElementIdGet: (
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<SoilElementResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/elements/${elementId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name UpdateSoilElementApiV1SoilChemistryElementsElementIdPut
     * @summary Update a soil element catalog item
     * @request PUT:/api/v1/soil-chemistry/elements/{element_id}
     */
    updateSoilElementApiV1SoilChemistryElementsElementIdPut: (
      elementId: string,
      data: SoilElementUpdate,
      params: RequestParams = {},
    ) =>
      this.request<SoilElementResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/elements/${elementId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name DeleteSoilElementApiV1SoilChemistryElementsElementIdDelete
     * @summary Delete a soil element catalog item
     * @request DELETE:/api/v1/soil-chemistry/elements/{element_id}
     */
    deleteSoilElementApiV1SoilChemistryElementsElementIdDelete: (
      elementId: string,
      params: RequestParams = {},
    ) =>
      this.request<SoilElementResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/elements/${elementId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name CreateSoilSampleApiV1SoilChemistrySamplesPost
     * @summary Create a new soil sample
     * @request POST:/api/v1/soil-chemistry/samples
     */
    createSoilSampleApiV1SoilChemistrySamplesPost: (
      data: SoilSampleCreate,
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleDetailResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/samples`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name ListSoilSamplesApiV1SoilChemistrySamplesGet
     * @summary List soil samples with filters
     * @request GET:/api/v1/soil-chemistry/samples
     */
    listSoilSamplesApiV1SoilChemistrySamplesGet: (
      query?: {
        /**
         * Location Id
         * Filter by location ID
         */
        location_id?: string | null;
        /**
         * Site Id
         * Filter by site ID
         */
        site_id?: string | null;
        /**
         * Project Id
         * Filter by project ID
         */
        project_id?: string | null;
        /**
         * Status
         * Filter by status (e.g. Collected, Analyzed)
         */
        status?: string | null;
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 500
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleListResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/samples`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name GetSoilSampleApiV1SoilChemistrySamplesSampleIdGet
     * @summary Get soil sample details including lab results
     * @request GET:/api/v1/soil-chemistry/samples/{sample_id}
     */
    getSoilSampleApiV1SoilChemistrySamplesSampleIdGet: (
      sampleId: string,
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleDetailResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/samples/${sampleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name UpdateSoilSampleApiV1SoilChemistrySamplesSampleIdPut
     * @summary Update a soil sample
     * @request PUT:/api/v1/soil-chemistry/samples/{sample_id}
     */
    updateSoilSampleApiV1SoilChemistrySamplesSampleIdPut: (
      sampleId: string,
      data: SoilSampleUpdate,
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleDetailResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/samples/${sampleId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name DeleteSoilSampleApiV1SoilChemistrySamplesSampleIdDelete
     * @summary Delete a soil sample
     * @request DELETE:/api/v1/soil-chemistry/samples/{sample_id}
     */
    deleteSoilSampleApiV1SoilChemistrySamplesSampleIdDelete: (
      sampleId: string,
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/samples/${sampleId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name ListSampleResultsApiV1SoilChemistrySamplesSampleIdResultsGet
     * @summary List all measurement results for a soil sample
     * @request GET:/api/v1/soil-chemistry/samples/{sample_id}/results
     */
    listSampleResultsApiV1SoilChemistrySamplesSampleIdResultsGet: (
      sampleId: string,
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleResultResponse[], HTTPValidationError>({
        path: `/api/v1/soil-chemistry/samples/${sampleId}/results`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name CreateOrUpdateSampleResultApiV1SoilChemistrySamplesSampleIdResultsPost
     * @summary Add or update a measurement result for a soil sample
     * @request POST:/api/v1/soil-chemistry/samples/{sample_id}/results
     */
    createOrUpdateSampleResultApiV1SoilChemistrySamplesSampleIdResultsPost: (
      sampleId: string,
      data: SoilSampleResultCreate,
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleResultResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/samples/${sampleId}/results`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name BulkCreateSampleResultsApiV1SoilChemistrySamplesSampleIdResultsBulkPost
     * @summary Bulk add or update measurement results for a soil sample
     * @request POST:/api/v1/soil-chemistry/samples/{sample_id}/results/bulk
     */
    bulkCreateSampleResultsApiV1SoilChemistrySamplesSampleIdResultsBulkPost: (
      sampleId: string,
      data: BulkSampleResultsCreate,
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleResultResponse[], HTTPValidationError>({
        path: `/api/v1/soil-chemistry/samples/${sampleId}/results/bulk`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name UpdateSampleResultApiV1SoilChemistrySamplesSampleIdResultsResultIdPut
     * @summary Update a measurement result for a soil sample
     * @request PUT:/api/v1/soil-chemistry/samples/{sample_id}/results/{result_id}
     */
    updateSampleResultApiV1SoilChemistrySamplesSampleIdResultsResultIdPut: (
      sampleId: string,
      resultId: string,
      data: SoilSampleResultUpdate,
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleResultResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/samples/${sampleId}/results/${resultId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name DeleteSampleResultApiV1SoilChemistrySamplesSampleIdResultsResultIdDelete
     * @summary Delete a measurement result from a soil sample
     * @request DELETE:/api/v1/soil-chemistry/samples/{sample_id}/results/{result_id}
     */
    deleteSampleResultApiV1SoilChemistrySamplesSampleIdResultsResultIdDelete: (
      sampleId: string,
      resultId: string,
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleResultResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/samples/${sampleId}/results/${resultId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name GetLocationSoilSamplesApiV1SoilChemistryLocationsLocationIdSamplesGet
     * @summary Get all soil samples for a specific location
     * @request GET:/api/v1/soil-chemistry/locations/{location_id}/samples
     */
    getLocationSoilSamplesApiV1SoilChemistryLocationsLocationIdSamplesGet: (
      locationId: string,
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 500
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleListResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/locations/${locationId}/samples`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name GetSiteSoilSamplesApiV1SoilChemistrySitesSiteIdSamplesGet
     * @summary Get all soil samples across a site
     * @request GET:/api/v1/soil-chemistry/sites/{site_id}/samples
     */
    getSiteSoilSamplesApiV1SoilChemistrySitesSiteIdSamplesGet: (
      siteId: string,
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 500
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleListResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/sites/${siteId}/samples`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Soil Chemistry
     * @name GetProjectSoilSamplesApiV1SoilChemistryProjectsProjectIdSamplesGet
     * @summary Get all soil samples across a project
     * @request GET:/api/v1/soil-chemistry/projects/{project_id}/samples
     */
    getProjectSoilSamplesApiV1SoilChemistryProjectsProjectIdSamplesGet: (
      projectId: string,
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 500
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SoilSampleListResponse, HTTPValidationError>({
        path: `/api/v1/soil-chemistry/projects/${projectId}/samples`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
